/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AIAssistantFeedbackBody } from '../models';
// @ts-ignore
import type { AIEnhanceQuestionBody } from '../models';
// @ts-ignore
import type { AIGenerationTaskListResponse } from '../models';
// @ts-ignore
import type { AIGenerationTaskResponse } from '../models';
// @ts-ignore
import type { AIHierarchyQuestionGenerationBody } from '../models';
// @ts-ignore
import type { AIQuestionGenerationBody } from '../models';
// @ts-ignore
import type { AcceptAiInviteResponse } from '../models';
// @ts-ignore
import type { AdminCreateUserGoalBody } from '../models';
// @ts-ignore
import type { AdminPersonaCreateBody } from '../models';
// @ts-ignore
import type { AdminPersonaCreateResponse } from '../models';
// @ts-ignore
import type { AdminPersonaListResponse } from '../models';
// @ts-ignore
import type { AdminPersonaUpdateBody } from '../models';
// @ts-ignore
import type { AiInviteRunNowResponse } from '../models';
// @ts-ignore
import type { AiInviteSettingUpdateBody } from '../models';
// @ts-ignore
import type { AiInviteSettingsResponse } from '../models';
// @ts-ignore
import type { AnsweredQuestionResponse } from '../models';
// @ts-ignore
import type { ApplyAIEnhanceBody } from '../models';
// @ts-ignore
import type { ApplyAIEnhanceResponse } from '../models';
// @ts-ignore
import type { AttemptHistoryResponse } from '../models';
// @ts-ignore
import type { AttemptInfoResponse } from '../models';
// @ts-ignore
import type { AttemptQuestionBody } from '../models';
// @ts-ignore
import type { AttemptQuestionCompetitionResponse } from '../models';
// @ts-ignore
import type { AttemptQuestionResponse } from '../models';
// @ts-ignore
import type { BookmarkQuestionBody } from '../models';
// @ts-ignore
import type { BulkActionsReviewQuestionBody } from '../models';
// @ts-ignore
import type { BulkActionsReviewQuestionBodyResponse } from '../models';
// @ts-ignore
import type { BulkUpdateUnderReviewStatusParam } from '../models';
// @ts-ignore
import type { CreateQuestionBody } from '../models';
// @ts-ignore
import type { CreateUserGoalBody } from '../models';
// @ts-ignore
import type { DuplicateQuestion } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ExitMultiplayerRoomBody } from '../models';
// @ts-ignore
import type { GeneratePromptCurriculumBody } from '../models';
// @ts-ignore
import type { GeneratePromptCurriculumResponse } from '../models';
// @ts-ignore
import type { GetAdminSkillTreeResponse } from '../models';
// @ts-ignore
import type { GetAttemptByIdResponse } from '../models';
// @ts-ignore
import type { GetBlockedUsersResponse } from '../models';
// @ts-ignore
import type { GetMultiplayerGamesListResponse } from '../models';
// @ts-ignore
import type { GetMultiplayerGamesResponse } from '../models';
// @ts-ignore
import type { GetQuestionAIAssistantResponse } from '../models';
// @ts-ignore
import type { GetQuestionHintResponse } from '../models';
// @ts-ignore
import type { GetQuestionStatisticsResponse } from '../models';
// @ts-ignore
import type { GetSkillTreeResponse } from '../models';
// @ts-ignore
import type { GetSolutionResponse } from '../models';
// @ts-ignore
import type { GetUnderReviewQuestionResponse } from '../models';
// @ts-ignore
import type { GetUserGoalResponse } from '../models';
// @ts-ignore
import type { HostTransferBody } from '../models';
// @ts-ignore
import type { LikeDislikeQuestionBody } from '../models';
// @ts-ignore
import type { LikeDislikeQuestionResponse } from '../models';
// @ts-ignore
import type { MultiplayerAttemptQuestionResponse } from '../models';
// @ts-ignore
import type { MultiplayerGameHistoryResponse } from '../models';
// @ts-ignore
import type { MultiplayerGameInitializeBody } from '../models';
// @ts-ignore
import type { MultiplayerGameInitializeResponse } from '../models';
// @ts-ignore
import type { MultiplayerInvitePreferenceBody } from '../models';
// @ts-ignore
import type { MultiplayerInvitePreferenceResponse } from '../models';
// @ts-ignore
import type { MultiplayerInviteUsersBody } from '../models';
// @ts-ignore
import type { MultiplayerInviteUsersResponse } from '../models';
// @ts-ignore
import type { MultiplayerLeaderboardResponse } from '../models';
// @ts-ignore
import type { MultiplayerMuteInviterBody } from '../models';
// @ts-ignore
import type { MultiplayerMuteInviterResponse } from '../models';
// @ts-ignore
import type { MultiplayerNudgeUserBody } from '../models';
// @ts-ignore
import type { MultiplayerOfflineInviteResponse } from '../models';
// @ts-ignore
import type { MultiplayerPromptUpdateBody } from '../models';
// @ts-ignore
import type { MultiplayerPromptUpdateResponse } from '../models';
// @ts-ignore
import type { MultiplayerQuestionsGenerationBody } from '../models';
// @ts-ignore
import type { MultiplayerReactionBody } from '../models';
// @ts-ignore
import type { MultiplayerReadyResponse } from '../models';
// @ts-ignore
import type { MultiplayerReadyUsersResponse } from '../models';
// @ts-ignore
import type { MultiplayerRemoveOrBlockUserBody } from '../models';
// @ts-ignore
import type { MultiplayerRoomGameInfoResponse } from '../models';
// @ts-ignore
import type { MultiplayerRoomLeaderboardResponse } from '../models';
// @ts-ignore
import type { MultiplayerRoomNameUpdateBody } from '../models';
// @ts-ignore
import type { MultiplayerSessionHistoryResponse } from '../models';
// @ts-ignore
import type { MultiplayerSessionProgressResponse } from '../models';
// @ts-ignore
import type { MultiplayerSessionResponseBase } from '../models';
// @ts-ignore
import type { MultiplayerSessionStartStatisticsResponse } from '../models';
// @ts-ignore
import type { MultiplayerSkillUpdateResponse } from '../models';
// @ts-ignore
import type { MultiplayerStartWithPersonaResponse } from '../models';
// @ts-ignore
import type { MultiplayerStatsResponse } from '../models';
// @ts-ignore
import type { MultiplayerWidenSkillSearchResponse } from '../models';
// @ts-ignore
import type { NestedSkillID } from '../models';
// @ts-ignore
import type { PastPromptsResponse } from '../models';
// @ts-ignore
import type { QuestionAIAssistantBody } from '../models';
// @ts-ignore
import type { QuestionAIAssistantResponse } from '../models';
// @ts-ignore
import type { QuestionAIReviewResponse } from '../models';
// @ts-ignore
import type { QuestionCreationMilestoneResponse } from '../models';
// @ts-ignore
import type { QuestionExplanationResponse } from '../models';
// @ts-ignore
import type { QuestionPublicAttemptBody } from '../models';
// @ts-ignore
import type { QuestionPublicAttemptResponse } from '../models';
// @ts-ignore
import type { QuestionResponseSchemaSkillDict } from '../models';
// @ts-ignore
import type { QuestionSkillHierarchyList } from '../models';
// @ts-ignore
import type { RecomputeDifficultyBody } from '../models';
// @ts-ignore
import type { RescaleQuestionEmbeddingDimensions } from '../models';
// @ts-ignore
import type { RescaleQuestionEmbeddingDimensionsResponse } from '../models';
// @ts-ignore
import type { RespondAiInviteBody } from '../models';
// @ts-ignore
import type { SimilarQuestionsList } from '../models';
// @ts-ignore
import type { SkillBuilderGetMultiplayerRoomDetailsPublicResponse } from '../models';
// @ts-ignore
import type { SkillBuilderGetMultiplayerRoomDetailsResponse } from '../models';
// @ts-ignore
import type { SkillBuilderMultiplayerHostSessionParam } from '../models';
// @ts-ignore
import type { SkillBuilderMultiplayerJoinSessionParam } from '../models';
// @ts-ignore
import type { SkillID } from '../models';
// @ts-ignore
import type { SkillStartSessionResponse } from '../models';
// @ts-ignore
import type { SolutionRatingBody } from '../models';
// @ts-ignore
import type { SolutionRatingResponse } from '../models';
// @ts-ignore
import type { SuccessData } from '../models';
// @ts-ignore
import type { SuccessMsg } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { TransferRoomAdminBody } from '../models';
// @ts-ignore
import type { TransferRoomAdminResponse } from '../models';
// @ts-ignore
import type { UnansweredQuestionResponseSchemaSkillDict } from '../models';
// @ts-ignore
import type { UnansweredSkillQuestionBody } from '../models';
// @ts-ignore
import type { UnblockMultiplayerUserBody } from '../models';
// @ts-ignore
import type { UpdateOptionBody } from '../models';
// @ts-ignore
import type { UpdateOptionResponse } from '../models';
// @ts-ignore
import type { UpdateQuestionBody } from '../models';
// @ts-ignore
import type { UpdateUnderReviewBody } from '../models';
// @ts-ignore
import type { UpdateUserGoalBody } from '../models';
// @ts-ignore
import type { UpsertUserSkillTreeBody } from '../models';
// @ts-ignore
import type { UserQuestionFeedbackParam } from '../models';
// @ts-ignore
import type { UserSessionEndParam } from '../models';
// @ts-ignore
import type { UserSessionEndRespons } from '../models';
// @ts-ignore
import type { UserSkillMilestoneResponse } from '../models';
/**
 * QuestionApiApi - axios parameter creator
 */
export const QuestionApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAcceptAiMultiplayerInvite: async (batchId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('questionApiAcceptAiMultiplayerInvite', 'batchId', batchId)
            const localVarPath = `/multiplayer/ai-invites/{batch_id}/accept`
                .replace('{batch_id}', encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminCreateUserGoalBody} adminCreateUserGoalBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAdminCreateUserGoal: async (adminCreateUserGoalBody: AdminCreateUserGoalBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCreateUserGoalBody' is not null or undefined
            assertParamExists('questionApiAdminCreateUserGoal', 'adminCreateUserGoalBody', adminCreateUserGoalBody)
            const localVarPath = `/admin/goal/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateUserGoalBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateQuestionBody} updateQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAdminUpdateQuestion: async (questionId: string, updateQuestionBody: UpdateQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiAdminUpdateQuestion', 'questionId', questionId)
            // verify required parameter 'updateQuestionBody' is not null or undefined
            assertParamExists('questionApiAdminUpdateQuestion', 'updateQuestionBody', updateQuestionBody)
            const localVarPath = `/admin/question/{question_id}`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} questionId 
         * @param {AIAssistantFeedbackBody} aIAssistantFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAiAssistantFeedback: async (chatId: string, questionId: string, aIAssistantFeedbackBody: AIAssistantFeedbackBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatId' is not null or undefined
            assertParamExists('questionApiAiAssistantFeedback', 'chatId', chatId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiAiAssistantFeedback', 'questionId', questionId)
            // verify required parameter 'aIAssistantFeedbackBody' is not null or undefined
            assertParamExists('questionApiAiAssistantFeedback', 'aIAssistantFeedbackBody', aIAssistantFeedbackBody)
            const localVarPath = `/question/{question_id}/ai-assistant/{chat_id}/feedback`
                .replace('{chat_id}', encodeURIComponent(String(chatId)))
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIAssistantFeedbackBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {AIEnhanceQuestionBody} aIEnhanceQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAiEnhanceQuestion: async (questionId: string, aIEnhanceQuestionBody: AIEnhanceQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiAiEnhanceQuestion', 'questionId', questionId)
            // verify required parameter 'aIEnhanceQuestionBody' is not null or undefined
            assertParamExists('questionApiAiEnhanceQuestion', 'aIEnhanceQuestionBody', aIEnhanceQuestionBody)
            const localVarPath = `/question/{question_id}/ai-enhance`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIEnhanceQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AIHierarchyQuestionGenerationBody} aIHierarchyQuestionGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAiHierarchyQuestionGeneration: async (aIHierarchyQuestionGenerationBody: AIHierarchyQuestionGenerationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aIHierarchyQuestionGenerationBody' is not null or undefined
            assertParamExists('questionApiAiHierarchyQuestionGeneration', 'aIHierarchyQuestionGenerationBody', aIHierarchyQuestionGenerationBody)
            const localVarPath = `/admin/hierarchy/ai-question-generation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIHierarchyQuestionGenerationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AIQuestionGenerationBody} aIQuestionGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAiSelfQuestionGeneration: async (aIQuestionGenerationBody: AIQuestionGenerationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aIQuestionGenerationBody' is not null or undefined
            assertParamExists('questionApiAiSelfQuestionGeneration', 'aIQuestionGenerationBody', aIQuestionGenerationBody)
            const localVarPath = `/admin/ai-self-question-generation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aIQuestionGenerationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {ApplyAIEnhanceBody} applyAIEnhanceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiApplyAiEnhanceQuestion: async (questionId: string, applyAIEnhanceBody: ApplyAIEnhanceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiApplyAiEnhanceQuestion', 'questionId', questionId)
            // verify required parameter 'applyAIEnhanceBody' is not null or undefined
            assertParamExists('questionApiApplyAiEnhanceQuestion', 'applyAIEnhanceBody', applyAIEnhanceBody)
            const localVarPath = `/question/{question_id}/ai-enhance/apply`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(applyAIEnhanceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} roomId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAttemptMultiplayerQuestion: async (questionId: string, roomId: string, attemptQuestionBody: AttemptQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiAttemptMultiplayerQuestion', 'questionId', questionId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiAttemptMultiplayerQuestion', 'roomId', roomId)
            // verify required parameter 'attemptQuestionBody' is not null or undefined
            assertParamExists('questionApiAttemptMultiplayerQuestion', 'attemptQuestionBody', attemptQuestionBody)
            const localVarPath = `/multiplayer/room/{room_id}/question/{question_id}/attempt`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} sessionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAttemptQuestion: async (questionId: string, sessionId: string, attemptQuestionBody: AttemptQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiAttemptQuestion', 'questionId', questionId)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('questionApiAttemptQuestion', 'sessionId', sessionId)
            // verify required parameter 'attemptQuestionBody' is not null or undefined
            assertParamExists('questionApiAttemptQuestion', 'attemptQuestionBody', attemptQuestionBody)
            const localVarPath = `/session/{session_id}/question/{question_id}/attempt`
                .replace('{question_id}', encodeURIComponent(String(questionId)))
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} questionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAttemptQuestionByCompetition: async (competitionId: string, questionId: string, attemptQuestionBody: AttemptQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'competitionId' is not null or undefined
            assertParamExists('questionApiAttemptQuestionByCompetition', 'competitionId', competitionId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiAttemptQuestionByCompetition', 'questionId', questionId)
            // verify required parameter 'attemptQuestionBody' is not null or undefined
            assertParamExists('questionApiAttemptQuestionByCompetition', 'attemptQuestionBody', attemptQuestionBody)
            const localVarPath = `/competition/{competition_id}/question/{question_id}/attempt`
                .replace('{competition_id}', encodeURIComponent(String(competitionId)))
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attemptQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {BookmarkQuestionBody} bookmarkQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiBookmarkQuestion: async (questionId: string, bookmarkQuestionBody: BookmarkQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiBookmarkQuestion', 'questionId', questionId)
            // verify required parameter 'bookmarkQuestionBody' is not null or undefined
            assertParamExists('questionApiBookmarkQuestion', 'bookmarkQuestionBody', bookmarkQuestionBody)
            const localVarPath = `/question/{question_id}/bookmark`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookmarkQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkActionsReviewQuestionBody} bulkActionsReviewQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiBulkActionsReviewQuestions: async (bulkActionsReviewQuestionBody: BulkActionsReviewQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkActionsReviewQuestionBody' is not null or undefined
            assertParamExists('questionApiBulkActionsReviewQuestions', 'bulkActionsReviewQuestionBody', bulkActionsReviewQuestionBody)
            const localVarPath = `/admin/bulk-action-review-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkActionsReviewQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DuplicateQuestion} duplicateQuestion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiBulkBlockDuplicates: async (duplicateQuestion: DuplicateQuestion, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'duplicateQuestion' is not null or undefined
            assertParamExists('questionApiBulkBlockDuplicates', 'duplicateQuestion', duplicateQuestion)
            const localVarPath = `/admin/question/bulk_block_duplicates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicateQuestion, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCheckAndGeneratePromptQuestionsAvailability: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiCheckAndGeneratePromptQuestionsAvailability', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiCheckAndGeneratePromptQuestionsAvailability', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/check-and-generate-questions`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminPersonaCreateBody} adminPersonaCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCreateMultiplayerPersona: async (adminPersonaCreateBody: AdminPersonaCreateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminPersonaCreateBody' is not null or undefined
            assertParamExists('questionApiCreateMultiplayerPersona', 'adminPersonaCreateBody', adminPersonaCreateBody)
            const localVarPath = `/admin/multiplayer/persona`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPersonaCreateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateQuestionBody} createQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCreateQuestion: async (createQuestionBody: CreateQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createQuestionBody' is not null or undefined
            assertParamExists('questionApiCreateQuestion', 'createQuestionBody', createQuestionBody)
            const localVarPath = `/question`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCreateSlugTestapi: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiCreateSlugTestapi', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/create_slug`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateUserGoalBody} createUserGoalBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCreateUserGoal: async (createUserGoalBody: CreateUserGoalBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserGoalBody' is not null or undefined
            assertParamExists('questionApiCreateUserGoal', 'createUserGoalBody', createUserGoalBody)
            const localVarPath = `/goal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserGoalBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiDeleteBlockedQuestionApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/question/delete-blocked-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExitMultiplayerRoomBody} exitMultiplayerRoomBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiDeleteMultiplayerRoom: async (exitMultiplayerRoomBody: ExitMultiplayerRoomBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exitMultiplayerRoomBody' is not null or undefined
            assertParamExists('questionApiDeleteMultiplayerRoom', 'exitMultiplayerRoomBody', exitMultiplayerRoomBody)
            const localVarPath = `/multiplayer/room/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exitMultiplayerRoomBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiDeleteQuestion: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiDeleteQuestion', 'questionId', questionId)
            const localVarPath = `/question/{question_id}`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiDeleteUserSkillHierarchy: async (skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('questionApiDeleteUserSkillHierarchy', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/delete-skill-hierarchy`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiEndMultiplayerGameByHost: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiEndMultiplayerGameByHost', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiEndMultiplayerGameByHost', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/game-end-host`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiEscapeHtmlCharacters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/question/escape-html-character`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExitMultiplayerRoomBody} exitMultiplayerRoomBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiExitMultiplayerRoom: async (exitMultiplayerRoomBody: ExitMultiplayerRoomBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exitMultiplayerRoomBody' is not null or undefined
            assertParamExists('questionApiExitMultiplayerRoom', 'exitMultiplayerRoomBody', exitMultiplayerRoomBody)
            const localVarPath = `/multiplayer/room/exit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exitMultiplayerRoomBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {GeneratePromptCurriculumBody} generatePromptCurriculumBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGeneratePromptCurriculum: async (roomId: string, generatePromptCurriculumBody: GeneratePromptCurriculumBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiGeneratePromptCurriculum', 'roomId', roomId)
            // verify required parameter 'generatePromptCurriculumBody' is not null or undefined
            assertParamExists('questionApiGeneratePromptCurriculum', 'generatePromptCurriculumBody', generatePromptCurriculumBody)
            const localVarPath = `/multiplayer/room/{room_id}/prompt/generate-curriculum`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generatePromptCurriculumBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {number} [duplicateCutoff] 
         * @param {boolean} [includeNoQuestionsSkills] 
         * @param {boolean} [showDuplicate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAdminSkillTree: async (skillId: string, duplicateCutoff?: number, includeNoQuestionsSkills?: boolean, showDuplicate?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('questionApiGetAdminSkillTree', 'skillId', skillId)
            const localVarPath = `/admin/skill/{skill_id}/get-skill-tree`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (duplicateCutoff !== undefined) {
                localVarQueryParameter['duplicate_cutoff'] = duplicateCutoff;
            }

            if (includeNoQuestionsSkills !== undefined) {
                localVarQueryParameter['include_no_questions_skills'] = includeNoQuestionsSkills;
            }

            if (showDuplicate !== undefined) {
                localVarQueryParameter['show_duplicate'] = showDuplicate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The AI-invite settings with what they produce right now (a dry run).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAiMultiplayerInviteSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/multiplayer/ai-invites/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAiQuestionGenerationStatus: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('questionApiGetAiQuestionGenerationStatus', 'taskId', taskId)
            const localVarPath = `/admin/hierarchy/ai-question-generation/{task_id}/status`
                .replace('{task_id}', encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAllAiGenerationTasks: async (page?: string, pageSize?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/hierarchy/get-all-ai-generation-tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAnsweredAttemptById: async (attemptId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attemptId' is not null or undefined
            assertParamExists('questionApiGetAnsweredAttemptById', 'attemptId', attemptId)
            const localVarPath = `/question/answered/{attempt_id}`
                .replace('{attempt_id}', encodeURIComponent(String(attemptId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {boolean} [newestFirst] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [skillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAnsweredQuestionHistoryList: async (competitionId?: string, newestFirst?: boolean, page?: string, pageSize?: string, skillId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/question/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (competitionId !== undefined) {
                localVarQueryParameter['competition_id'] = competitionId;
            }

            if (newestFirst !== undefined) {
                localVarQueryParameter['newest_first'] = newestFirst;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (skillId !== undefined) {
                localVarQueryParameter['skill_id'] = skillId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {string} [examId] 
         * @param {string} [filterType] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchString] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAnsweredQuestionList: async (competitionId?: string, examId?: string, filterType?: string, page?: number, pageSize?: number, searchString?: string, skillIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/question/answered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (competitionId !== undefined) {
                localVarQueryParameter['competition_id'] = competitionId;
            }

            if (examId !== undefined) {
                localVarQueryParameter['exam_id'] = examId;
            }

            if (filterType !== undefined) {
                localVarQueryParameter['filter_type'] = filterType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (searchString !== undefined) {
                localVarQueryParameter['search_string'] = searchString;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetBlockedRoomUsers: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiGetBlockedRoomUsers', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/blocked-users`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetJoinedMultiplayerRooms: async (page?: number, pageSize?: number, totalPages?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/multiplayer-rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (totalPages !== undefined) {
                localVarQueryParameter['total_pages'] = totalPages;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerGameHistory: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiGetMultiplayerGameHistory', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game-history`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerGameInfo: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiGetMultiplayerGameInfo', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiGetMultiplayerGameInfo', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/game-info`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerReadyUsers: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiGetMultiplayerReadyUsers', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiGetMultiplayerReadyUsers', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/ready-users`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {boolean} [activeGameUsers] 
         * @param {boolean} [entering] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerRoomInfo: async (roomId: string, activeGameUsers?: boolean, entering?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiGetMultiplayerRoomInfo', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/get-room-info`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (activeGameUsers !== undefined) {
                localVarQueryParameter['active_game_users'] = activeGameUsers;
            }

            if (entering !== undefined) {
                localVarQueryParameter['entering'] = entering;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerSessionHistory: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiGetMultiplayerSessionHistory', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiGetMultiplayerSessionHistory', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/session-history`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/multiplayer/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [roomId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetPastPrompts: async (roomId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/multiplayer/past-prompts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (roomId !== undefined) {
                localVarQueryParameter['room_id'] = roomId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetPublicMultiplayerRoomInfo: async (roomCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomCode' is not null or undefined
            assertParamExists('questionApiGetPublicMultiplayerRoomInfo', 'roomCode', roomCode)
            const localVarPath = `/public/multiplayer/room/{room_code}/get-room-info`
                .replace('{room_code}', encodeURIComponent(String(roomCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionAiAssistantChats: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetQuestionAiAssistantChats', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/ai-assistant-chats`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionAttemptData: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetQuestionAttemptData', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/attempt_info`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} [subQuestions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionById: async (questionId: string, subQuestions?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetQuestionById', 'questionId', questionId)
            const localVarPath = `/question/{question_id}`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (subQuestions !== undefined) {
                localVarQueryParameter['sub_questions'] = subQuestions;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionExplanation: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetQuestionExplanation', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/explanation`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionHint: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetQuestionHint', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/hint`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionReviewData: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetQuestionReviewData', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/get-review-data`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionSkillHierarchies: async (ids?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/question/skill-hierarchies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionStatistics: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetQuestionStatistics', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/statistics`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [duplicate] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [questionStatus] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionUnderreviewList: async (duplicate?: string, page?: string, pageSize?: string, questionStatus?: string, sortBy?: string, sortOrder?: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/question/underreview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (duplicate !== undefined) {
                localVarQueryParameter['duplicate'] = duplicate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (questionStatus !== undefined) {
                localVarQueryParameter['question_status'] = questionStatus;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetRoomPastPrompts: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiGetRoomPastPrompts', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/past-prompts`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetSessionProgressMetrics: async (sessionId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('questionApiGetSessionProgressMetrics', 'sessionId', sessionId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('questionApiGetSessionProgressMetrics', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/session/{session_id}/session-progress-metrics`
                .replace('{session_id}', encodeURIComponent(String(sessionId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetSimilarQuestions: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetSimilarQuestions', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/similar`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {boolean} [includeNoQuestionsSkills] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetSkillTree: async (skillId: string, includeNoQuestionsSkills?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('questionApiGetSkillTree', 'skillId', skillId)
            const localVarPath = `/skill/{skill_id}/get-skill-tree`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeNoQuestionsSkills !== undefined) {
                localVarQueryParameter['include_no_questions_skills'] = includeNoQuestionsSkills;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetSolution: async (questionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiGetSolution', 'questionId', questionId)
            const localVarPath = `/question/{question_id}/solution`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UnansweredSkillQuestionBody} unansweredSkillQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUnansweredQuestionBySkill: async (unansweredSkillQuestionBody: UnansweredSkillQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unansweredSkillQuestionBody' is not null or undefined
            assertParamExists('questionApiGetUnansweredQuestionBySkill', 'unansweredSkillQuestionBody', unansweredSkillQuestionBody)
            const localVarPath = `/question/unanswered`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unansweredSkillQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUnansweredQuestionSkillBuilder: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('questionApiGetUnansweredQuestionSkillBuilder', 'sessionId', sessionId)
            const localVarPath = `/skill-builder/session/{session_id}/question`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isArchived] 
         * @param {boolean} [isTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUserGoal: async (isArchived?: boolean, isTemplate?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/goal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (isArchived !== undefined) {
                localVarQueryParameter['is_archived'] = isArchived;
            }

            if (isTemplate !== undefined) {
                localVarQueryParameter['is_template'] = isTemplate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} goalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUserGoalById: async (goalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalId' is not null or undefined
            assertParamExists('questionApiGetUserGoalById', 'goalId', goalId)
            const localVarPath = `/goal/{goal_id}`
                .replace('{goal_id}', encodeURIComponent(String(goalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUserSkillMilestone: async (sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('questionApiGetUserSkillMilestone', 'sessionId', sessionId)
            const localVarPath = `/session/{session_id}/user-session-data`
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {HostTransferBody} hostTransferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiHandleHostTransferRequest: async (roomId: string, hostTransferBody: HostTransferBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiHandleHostTransferRequest', 'roomId', roomId)
            // verify required parameter 'hostTransferBody' is not null or undefined
            assertParamExists('questionApiHandleHostTransferRequest', 'hostTransferBody', hostTransferBody)
            const localVarPath = `/multiplayer/room/{room_id}/host-transfer`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hostTransferBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiHandleInactiveGame: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiHandleInactiveGame', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiHandleInactiveGame', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/game-end/resolve`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiHandleInactiveHostTransfer: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiHandleInactiveHostTransfer', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/host-transfer/resolve`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {HostTransferBody} hostTransferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiHandleMultiplayerGameEnd: async (roomId: string, hostTransferBody: HostTransferBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiHandleMultiplayerGameEnd', 'roomId', roomId)
            // verify required parameter 'hostTransferBody' is not null or undefined
            assertParamExists('questionApiHandleMultiplayerGameEnd', 'hostTransferBody', hostTransferBody)
            const localVarPath = `/multiplayer/room/{room_id}/game-end`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hostTransferBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerGameInitializeBody} multiplayerGameInitializeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiInitializeMultiplayerGame: async (roomId: string, multiplayerGameInitializeBody: MultiplayerGameInitializeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiInitializeMultiplayerGame', 'roomId', roomId)
            // verify required parameter 'multiplayerGameInitializeBody' is not null or undefined
            assertParamExists('questionApiInitializeMultiplayerGame', 'multiplayerGameInitializeBody', multiplayerGameInitializeBody)
            const localVarPath = `/multiplayer/room/{room_id}/initialize-game`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerGameInitializeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerInviteUsersBody} multiplayerInviteUsersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiInviteToMultiplayerRoom: async (roomId: string, multiplayerInviteUsersBody: MultiplayerInviteUsersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiInviteToMultiplayerRoom', 'roomId', roomId)
            // verify required parameter 'multiplayerInviteUsersBody' is not null or undefined
            assertParamExists('questionApiInviteToMultiplayerRoom', 'multiplayerInviteUsersBody', multiplayerInviteUsersBody)
            const localVarPath = `/multiplayer/room/{room_id}/invite`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerInviteUsersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiLeaveMultiplayerRoom: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiLeaveMultiplayerRoom', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/leave`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The AI opponent roster, with how each character has actually been playing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiListMultiplayerPersonas: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/multiplayer/personas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {string | null} [gameId] 
         * @param {string} [resultType] 
         * @param {string | null} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiMultiplayerLeaderboard: async (roomId: string, gameId?: string | null, resultType?: string, sessionId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiMultiplayerLeaderboard', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/leaderboard`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (gameId !== undefined) {
                localVarQueryParameter['game_id'] = gameId;
            }

            if (resultType !== undefined) {
                localVarQueryParameter['result_type'] = resultType;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiMultiplayerReadyForNextSession: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiMultiplayerReadyForNextSession', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiMultiplayerReadyForNextSession', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/ready`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiMultiplayerRoomLeaderboard: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiMultiplayerRoomLeaderboard', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/overall-leaderboard`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MultiplayerMuteInviterBody} multiplayerMuteInviterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiMuteMultiplayerInviter: async (multiplayerMuteInviterBody: MultiplayerMuteInviterBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'multiplayerMuteInviterBody' is not null or undefined
            assertParamExists('questionApiMuteMultiplayerInviter', 'multiplayerMuteInviterBody', multiplayerMuteInviterBody)
            const localVarPath = `/multiplayer/invites/mute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerMuteInviterBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {MultiplayerNudgeUserBody} multiplayerNudgeUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiNudgeMulplayerUser: async (gameId: string, roomId: string, multiplayerNudgeUserBody: MultiplayerNudgeUserBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiNudgeMulplayerUser', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiNudgeMulplayerUser', 'roomId', roomId)
            // verify required parameter 'multiplayerNudgeUserBody' is not null or undefined
            assertParamExists('questionApiNudgeMulplayerUser', 'multiplayerNudgeUserBody', multiplayerNudgeUserBody)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/nudge`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerNudgeUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerNudgeUserBody} multiplayerNudgeUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiNudgeMulplayerUserInRoom: async (roomId: string, multiplayerNudgeUserBody: MultiplayerNudgeUserBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiNudgeMulplayerUserInRoom', 'roomId', roomId)
            // verify required parameter 'multiplayerNudgeUserBody' is not null or undefined
            assertParamExists('questionApiNudgeMulplayerUserInRoom', 'multiplayerNudgeUserBody', multiplayerNudgeUserBody)
            const localVarPath = `/multiplayer/room/{room_id}/nudge`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerNudgeUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiPopulateQuestionMetadata: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/question/populate_question_metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillID} skillID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiPopulateQuestionSimilarityEmbeddings: async (skillID: SkillID, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillID' is not null or undefined
            assertParamExists('questionApiPopulateQuestionSimilarityEmbeddings', 'skillID', skillID)
            const localVarPath = `/admin/question/populate_question_similarity_embeddings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillID, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {MultiplayerQuestionsGenerationBody} multiplayerQuestionsGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiPromptBasedQuestionsGeneration: async (gameId: string, roomId: string, multiplayerQuestionsGenerationBody: MultiplayerQuestionsGenerationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiPromptBasedQuestionsGeneration', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiPromptBasedQuestionsGeneration', 'roomId', roomId)
            // verify required parameter 'multiplayerQuestionsGenerationBody' is not null or undefined
            assertParamExists('questionApiPromptBasedQuestionsGeneration', 'multiplayerQuestionsGenerationBody', multiplayerQuestionsGenerationBody)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/questions-generation`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerQuestionsGenerationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {QuestionAIAssistantBody} questionAIAssistantBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiQuestionAiAssistant: async (questionId: string, questionAIAssistantBody: QuestionAIAssistantBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiQuestionAiAssistant', 'questionId', questionId)
            // verify required parameter 'questionAIAssistantBody' is not null or undefined
            assertParamExists('questionApiQuestionAiAssistant', 'questionAIAssistantBody', questionAIAssistantBody)
            const localVarPath = `/question/{question_id}/ai-assistant`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionAIAssistantBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiQuestionCreateMilestone: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/question/milestone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {LikeDislikeQuestionBody} likeDislikeQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiQuestionLike: async (questionId: string, likeDislikeQuestionBody: LikeDislikeQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiQuestionLike', 'questionId', questionId)
            // verify required parameter 'likeDislikeQuestionBody' is not null or undefined
            assertParamExists('questionApiQuestionLike', 'likeDislikeQuestionBody', likeDislikeQuestionBody)
            const localVarPath = `/question/{question_id}/like_dislike`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(likeDislikeQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<QuestionPublicAttemptBody>} questionPublicAttemptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiQuestionPublicAttempt: async (questionPublicAttemptBody: Array<QuestionPublicAttemptBody>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionPublicAttemptBody' is not null or undefined
            assertParamExists('questionApiQuestionPublicAttempt', 'questionPublicAttemptBody', questionPublicAttemptBody)
            const localVarPath = `/question/public-attempt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionPublicAttemptBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * enough real attempts from its correct rate. Runs async on the worker; optional `skill_ids` in the JSON body scope it to questions in those skills.
         * @summary Kick off the statistical difficulty recompute: re-levels every question with
         * @param {RecomputeDifficultyBody} recomputeDifficultyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRecomputeQuestionDifficulty: async (recomputeDifficultyBody: RecomputeDifficultyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recomputeDifficultyBody' is not null or undefined
            assertParamExists('questionApiRecomputeQuestionDifficulty', 'recomputeDifficultyBody', recomputeDifficultyBody)
            const localVarPath = `/admin/question/difficulty/recompute`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recomputeDifficultyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRecordMultiplayerInviteClick: async (inviteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('questionApiRecordMultiplayerInviteClick', 'inviteId', inviteId)
            const localVarPath = `/multiplayer/invites/{invite_id}/click`
                .replace('{invite_id}', encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerRemoveOrBlockUserBody} multiplayerRemoveOrBlockUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRemoveOrBlockMultiplayerUser: async (roomId: string, multiplayerRemoveOrBlockUserBody: MultiplayerRemoveOrBlockUserBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiRemoveOrBlockMultiplayerUser', 'roomId', roomId)
            // verify required parameter 'multiplayerRemoveOrBlockUserBody' is not null or undefined
            assertParamExists('questionApiRemoveOrBlockMultiplayerUser', 'multiplayerRemoveOrBlockUserBody', multiplayerRemoveOrBlockUserBody)
            const localVarPath = `/multiplayer/room/{room_id}/remove-or-block`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerRemoveOrBlockUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiReplaceExternalImagesApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/question/update_external_image_urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiReplaceExternalTextsApi: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/question/update_external_text_urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRequestHostChange: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiRequestHostChange', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/request-host-change`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRequestMultiplayerGameEnd: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiRequestMultiplayerGameEnd', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiRequestMultiplayerGameEnd', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/request-game-end`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RescaleQuestionEmbeddingDimensions} rescaleQuestionEmbeddingDimensions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRescaleQuestionEmbeddingDimensions: async (rescaleQuestionEmbeddingDimensions: RescaleQuestionEmbeddingDimensions, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rescaleQuestionEmbeddingDimensions' is not null or undefined
            assertParamExists('questionApiRescaleQuestionEmbeddingDimensions', 'rescaleQuestionEmbeddingDimensions', rescaleQuestionEmbeddingDimensions)
            const localVarPath = `/admin/question/rescale-embedding-dimensions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rescaleQuestionEmbeddingDimensions, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchId 
         * @param {RespondAiInviteBody} respondAiInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRespondAiMultiplayerInvite: async (batchId: string, respondAiInviteBody: RespondAiInviteBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchId' is not null or undefined
            assertParamExists('questionApiRespondAiMultiplayerInvite', 'batchId', batchId)
            // verify required parameter 'respondAiInviteBody' is not null or undefined
            assertParamExists('questionApiRespondAiMultiplayerInvite', 'respondAiInviteBody', respondAiInviteBody)
            const localVarPath = `/multiplayer/ai-invites/{batch_id}/respond`
                .replace('{batch_id}', encodeURIComponent(String(batchId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(respondAiInviteBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary One tick now, ignoring the send frequency. Sends only if sending is on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRunAiMultiplayerInvitesNow: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/multiplayer/ai-invites/run-now`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiScheduleMultiplayerOfflineInvites: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiScheduleMultiplayerOfflineInvites', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/invite-offline`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {MultiplayerReactionBody} multiplayerReactionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSendMultiplayerReaction: async (gameId: string, roomId: string, multiplayerReactionBody: MultiplayerReactionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiSendMultiplayerReaction', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiSendMultiplayerReaction', 'roomId', roomId)
            // verify required parameter 'multiplayerReactionBody' is not null or undefined
            assertParamExists('questionApiSendMultiplayerReaction', 'multiplayerReactionBody', multiplayerReactionBody)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/reaction`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerReactionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MultiplayerInvitePreferenceBody} multiplayerInvitePreferenceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSetMultiplayerInvitePreference: async (multiplayerInvitePreferenceBody: MultiplayerInvitePreferenceBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'multiplayerInvitePreferenceBody' is not null or undefined
            assertParamExists('questionApiSetMultiplayerInvitePreference', 'multiplayerInvitePreferenceBody', multiplayerInvitePreferenceBody)
            const localVarPath = `/multiplayer/invites/preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerInvitePreferenceBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillBuilderMultiplayerHostSessionParam} skillBuilderMultiplayerHostSessionParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerHost: async (skillBuilderMultiplayerHostSessionParam: SkillBuilderMultiplayerHostSessionParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillBuilderMultiplayerHostSessionParam' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerHost', 'skillBuilderMultiplayerHostSessionParam', skillBuilderMultiplayerHostSessionParam)
            const localVarPath = `/multiplayer/host`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillBuilderMultiplayerHostSessionParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SkillBuilderMultiplayerJoinSessionParam} skillBuilderMultiplayerJoinSessionParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerJoin: async (skillBuilderMultiplayerJoinSessionParam: SkillBuilderMultiplayerJoinSessionParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillBuilderMultiplayerJoinSessionParam' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerJoin', 'skillBuilderMultiplayerJoinSessionParam', skillBuilderMultiplayerJoinSessionParam)
            const localVarPath = `/skill-builder/multiplayer/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skillBuilderMultiplayerJoinSessionParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerSessionProgress: async (roomId: string, sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerSessionProgress', 'roomId', roomId)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerSessionProgress', 'sessionId', sessionId)
            const localVarPath = `/multiplayer/room/{room_id}/session/{session_id}/progress`
                .replace('{room_id}', encodeURIComponent(String(roomId)))
                .replace('{session_id}', encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerSessionStartStatistics: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerSessionStartStatistics', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/start-statistics`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerStartSession: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerStartSession', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerStartSession', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/start-session`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerStartWithPersona: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerStartWithPersona', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiSkillBuilderMultiplayerStartWithPersona', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/start-with-persona`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {string} skillId 
         * @param {UserSessionEndParam} userSessionEndParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderSessionEnd: async (sessionId: string, skillId: string, userSessionEndParam: UserSessionEndParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('questionApiSkillBuilderSessionEnd', 'sessionId', sessionId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('questionApiSkillBuilderSessionEnd', 'skillId', skillId)
            // verify required parameter 'userSessionEndParam' is not null or undefined
            assertParamExists('questionApiSkillBuilderSessionEnd', 'userSessionEndParam', userSessionEndParam)
            const localVarPath = `/skill/{skill_id}/session/{session_id}/end-session`
                .replace('{session_id}', encodeURIComponent(String(sessionId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSessionEndParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {NestedSkillID} nestedSkillID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderSessionStart: async (skillId: string, nestedSkillID: NestedSkillID, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('questionApiSkillBuilderSessionStart', 'skillId', skillId)
            // verify required parameter 'nestedSkillID' is not null or undefined
            assertParamExists('questionApiSkillBuilderSessionStart', 'nestedSkillID', nestedSkillID)
            const localVarPath = `/skill/{skill_id}/start-session`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nestedSkillID, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {SolutionRatingBody} solutionRatingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSolutionRating: async (questionId: string, solutionRatingBody: SolutionRatingBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiSolutionRating', 'questionId', questionId)
            // verify required parameter 'solutionRatingBody' is not null or undefined
            assertParamExists('questionApiSolutionRating', 'solutionRatingBody', solutionRatingBody)
            const localVarPath = `/question/{question_id}/solution-rating`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(solutionRatingBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiStopAiQuestionGeneration: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('questionApiStopAiQuestionGeneration', 'taskId', taskId)
            const localVarPath = `/admin/hierarchy/ai-question-generation/{task_id}/stop`
                .replace('{task_id}', encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {TransferRoomAdminBody} transferRoomAdminBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiTransferRoomAdmin: async (roomId: string, transferRoomAdminBody: TransferRoomAdminBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiTransferRoomAdmin', 'roomId', roomId)
            // verify required parameter 'transferRoomAdminBody' is not null or undefined
            assertParamExists('questionApiTransferRoomAdmin', 'transferRoomAdminBody', transferRoomAdminBody)
            const localVarPath = `/multiplayer/room/{room_id}/transfer-admin`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferRoomAdminBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {UnblockMultiplayerUserBody} unblockMultiplayerUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUnblockMultiplayerUser: async (roomId: string, unblockMultiplayerUserBody: UnblockMultiplayerUserBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiUnblockMultiplayerUser', 'roomId', roomId)
            // verify required parameter 'unblockMultiplayerUserBody' is not null or undefined
            assertParamExists('questionApiUnblockMultiplayerUser', 'unblockMultiplayerUserBody', unblockMultiplayerUserBody)
            const localVarPath = `/multiplayer/room/{room_id}/unblock-user`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unblockMultiplayerUserBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AiInviteSettingUpdateBody} aiInviteSettingUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateAiMultiplayerInviteSetting: async (aiInviteSettingUpdateBody: AiInviteSettingUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aiInviteSettingUpdateBody' is not null or undefined
            assertParamExists('questionApiUpdateAiMultiplayerInviteSetting', 'aiInviteSettingUpdateBody', aiInviteSettingUpdateBody)
            const localVarPath = `/admin/multiplayer/ai-invites/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aiInviteSettingUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateBookmarkCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/question/update_bookmark_count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * a delete would take the opponent off past players\' result screens.
         * @summary Rename, re-skin, re-band or retire a character. Retiring is is_active=False —
         * @param {string} personaId 
         * @param {AdminPersonaUpdateBody} adminPersonaUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateMultiplayerPersona: async (personaId: string, adminPersonaUpdateBody: AdminPersonaUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personaId' is not null or undefined
            assertParamExists('questionApiUpdateMultiplayerPersona', 'personaId', personaId)
            // verify required parameter 'adminPersonaUpdateBody' is not null or undefined
            assertParamExists('questionApiUpdateMultiplayerPersona', 'adminPersonaUpdateBody', adminPersonaUpdateBody)
            const localVarPath = `/admin/multiplayer/persona/{persona_id}`
                .replace('{persona_id}', encodeURIComponent(String(personaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminPersonaUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerPromptUpdateBody} multiplayerPromptUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateMultiplayerPromptText: async (roomId: string, multiplayerPromptUpdateBody: MultiplayerPromptUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiUpdateMultiplayerPromptText', 'roomId', roomId)
            // verify required parameter 'multiplayerPromptUpdateBody' is not null or undefined
            assertParamExists('questionApiUpdateMultiplayerPromptText', 'multiplayerPromptUpdateBody', multiplayerPromptUpdateBody)
            const localVarPath = `/multiplayer/room/{room_id}/update-prompt`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerPromptUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerRoomNameUpdateBody} multiplayerRoomNameUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateMultiplayerRoomName: async (roomId: string, multiplayerRoomNameUpdateBody: MultiplayerRoomNameUpdateBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiUpdateMultiplayerRoomName', 'roomId', roomId)
            // verify required parameter 'multiplayerRoomNameUpdateBody' is not null or undefined
            assertParamExists('questionApiUpdateMultiplayerRoomName', 'multiplayerRoomNameUpdateBody', multiplayerRoomNameUpdateBody)
            const localVarPath = `/multiplayer/room/{room_id}/update-room-name`
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(multiplayerRoomNameUpdateBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} roomId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateMultiplayerSkill: async (roomId: string, skillId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiUpdateMultiplayerSkill', 'roomId', roomId)
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('questionApiUpdateMultiplayerSkill', 'skillId', skillId)
            const localVarPath = `/multiplayer/room/{room_id}/skill/{skill_id}`
                .replace('{room_id}', encodeURIComponent(String(roomId)))
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateOptionBody} updateOptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateOption: async (updateOptionBody: UpdateOptionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateOptionBody' is not null or undefined
            assertParamExists('questionApiUpdateOption', 'updateOptionBody', updateOptionBody)
            const localVarPath = `/question/update_option`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOptionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateQuestionBody} updateQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateQuestion: async (questionId: string, updateQuestionBody: UpdateQuestionBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiUpdateQuestion', 'questionId', questionId)
            // verify required parameter 'updateQuestionBody' is not null or undefined
            assertParamExists('questionApiUpdateQuestion', 'updateQuestionBody', updateQuestionBody)
            const localVarPath = `/question/{question_id}`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateQuestionBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateUnderReviewBody} updateUnderReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateUnderReviewDetails: async (questionId: string, updateUnderReviewBody: UpdateUnderReviewBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiUpdateUnderReviewDetails', 'questionId', questionId)
            // verify required parameter 'updateUnderReviewBody' is not null or undefined
            assertParamExists('questionApiUpdateUnderReviewDetails', 'updateUnderReviewBody', updateUnderReviewBody)
            const localVarPath = `/question/{question_id}/review_status`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUnderReviewBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BulkUpdateUnderReviewStatusParam} bulkUpdateUnderReviewStatusParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateUnderReviewDetailsBulk: async (bulkUpdateUnderReviewStatusParam: BulkUpdateUnderReviewStatusParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bulkUpdateUnderReviewStatusParam' is not null or undefined
            assertParamExists('questionApiUpdateUnderReviewDetailsBulk', 'bulkUpdateUnderReviewStatusParam', bulkUpdateUnderReviewStatusParam)
            const localVarPath = `/question/bulk_review_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkUpdateUnderReviewStatusParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} goalId 
         * @param {UpdateUserGoalBody} updateUserGoalBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateUserGoal: async (goalId: string, updateUserGoalBody: UpdateUserGoalBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'goalId' is not null or undefined
            assertParamExists('questionApiUpdateUserGoal', 'goalId', goalId)
            // verify required parameter 'updateUserGoalBody' is not null or undefined
            assertParamExists('questionApiUpdateUserGoal', 'updateUserGoalBody', updateUserGoalBody)
            const localVarPath = `/goal/{goal_id}`
                .replace('{goal_id}', encodeURIComponent(String(goalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserGoalBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UserQuestionFeedbackParam} userQuestionFeedbackParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpsertUserQuestionFeedback: async (questionId: string, userQuestionFeedbackParam: UserQuestionFeedbackParam, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('questionApiUpsertUserQuestionFeedback', 'questionId', questionId)
            // verify required parameter 'userQuestionFeedbackParam' is not null or undefined
            assertParamExists('questionApiUpsertUserQuestionFeedback', 'userQuestionFeedbackParam', userQuestionFeedbackParam)
            const localVarPath = `/question/{question_id}/user/feedback`
                .replace('{question_id}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userQuestionFeedbackParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpsertUserSkillTreeBody} upsertUserSkillTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpsertUserSkillTree: async (skillId: string, upsertUserSkillTreeBody: UpsertUserSkillTreeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'skillId' is not null or undefined
            assertParamExists('questionApiUpsertUserSkillTree', 'skillId', skillId)
            // verify required parameter 'upsertUserSkillTreeBody' is not null or undefined
            assertParamExists('questionApiUpsertUserSkillTree', 'upsertUserSkillTreeBody', upsertUserSkillTreeBody)
            const localVarPath = `/skill/{skill_id}/upsert-user-skill-tree`
                .replace('{skill_id}', encodeURIComponent(String(skillId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(upsertUserSkillTreeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiWidenMultiplayerSkillSearch: async (gameId: string, roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gameId' is not null or undefined
            assertParamExists('questionApiWidenMultiplayerSkillSearch', 'gameId', gameId)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('questionApiWidenMultiplayerSkillSearch', 'roomId', roomId)
            const localVarPath = `/multiplayer/room/{room_id}/game/{game_id}/widen-skill-search`
                .replace('{game_id}', encodeURIComponent(String(gameId)))
                .replace('{room_id}', encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionApiApi - functional programming interface
 */
export const QuestionApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} batchId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAcceptAiMultiplayerInvite(batchId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AcceptAiInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAcceptAiMultiplayerInvite(batchId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAcceptAiMultiplayerInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminCreateUserGoalBody} adminCreateUserGoalBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAdminCreateUserGoal(adminCreateUserGoalBody: AdminCreateUserGoalBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAdminCreateUserGoal(adminCreateUserGoalBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAdminCreateUserGoal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateQuestionBody} updateQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAdminUpdateQuestion(questionId: string, updateQuestionBody: UpdateQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAdminUpdateQuestion(questionId, updateQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAdminUpdateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} chatId 
         * @param {string} questionId 
         * @param {AIAssistantFeedbackBody} aIAssistantFeedbackBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAiAssistantFeedback(chatId: string, questionId: string, aIAssistantFeedbackBody: AIAssistantFeedbackBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAiAssistantFeedback(chatId, questionId, aIAssistantFeedbackBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAiAssistantFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {AIEnhanceQuestionBody} aIEnhanceQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAiEnhanceQuestion(questionId: string, aIEnhanceQuestionBody: AIEnhanceQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAiEnhanceQuestion(questionId, aIEnhanceQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAiEnhanceQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AIHierarchyQuestionGenerationBody} aIHierarchyQuestionGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAiHierarchyQuestionGeneration(aIHierarchyQuestionGenerationBody: AIHierarchyQuestionGenerationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAiHierarchyQuestionGeneration(aIHierarchyQuestionGenerationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAiHierarchyQuestionGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AIQuestionGenerationBody} aIQuestionGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAiSelfQuestionGeneration(aIQuestionGenerationBody: AIQuestionGenerationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAiSelfQuestionGeneration(aIQuestionGenerationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAiSelfQuestionGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {ApplyAIEnhanceBody} applyAIEnhanceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiApplyAiEnhanceQuestion(questionId: string, applyAIEnhanceBody: ApplyAIEnhanceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplyAIEnhanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiApplyAiEnhanceQuestion(questionId, applyAIEnhanceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiApplyAiEnhanceQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} roomId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAttemptMultiplayerQuestion(questionId: string, roomId: string, attemptQuestionBody: AttemptQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerAttemptQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAttemptMultiplayerQuestion(questionId, roomId, attemptQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAttemptMultiplayerQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} sessionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAttemptQuestion(questionId: string, sessionId: string, attemptQuestionBody: AttemptQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAttemptQuestion(questionId, sessionId, attemptQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAttemptQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} competitionId 
         * @param {string} questionId 
         * @param {AttemptQuestionBody} attemptQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiAttemptQuestionByCompetition(competitionId: string, questionId: string, attemptQuestionBody: AttemptQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptQuestionCompetitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiAttemptQuestionByCompetition(competitionId, questionId, attemptQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiAttemptQuestionByCompetition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {BookmarkQuestionBody} bookmarkQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiBookmarkQuestion(questionId: string, bookmarkQuestionBody: BookmarkQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiBookmarkQuestion(questionId, bookmarkQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiBookmarkQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkActionsReviewQuestionBody} bulkActionsReviewQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiBulkActionsReviewQuestions(bulkActionsReviewQuestionBody: BulkActionsReviewQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkActionsReviewQuestionBodyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiBulkActionsReviewQuestions(bulkActionsReviewQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiBulkActionsReviewQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DuplicateQuestion} duplicateQuestion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiBulkBlockDuplicates(duplicateQuestion: DuplicateQuestion, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiBulkBlockDuplicates(duplicateQuestion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiBulkBlockDuplicates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiCheckAndGeneratePromptQuestionsAvailability(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiCheckAndGeneratePromptQuestionsAvailability(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiCheckAndGeneratePromptQuestionsAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminPersonaCreateBody} adminPersonaCreateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiCreateMultiplayerPersona(adminPersonaCreateBody: AdminPersonaCreateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPersonaCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiCreateMultiplayerPersona(adminPersonaCreateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiCreateMultiplayerPersona']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateQuestionBody} createQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiCreateQuestion(createQuestionBody: CreateQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiCreateQuestion(createQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiCreateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiCreateSlugTestapi(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiCreateSlugTestapi(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiCreateSlugTestapi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateUserGoalBody} createUserGoalBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiCreateUserGoal(createUserGoalBody: CreateUserGoalBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiCreateUserGoal(createUserGoalBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiCreateUserGoal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiDeleteBlockedQuestionApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiDeleteBlockedQuestionApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiDeleteBlockedQuestionApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExitMultiplayerRoomBody} exitMultiplayerRoomBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiDeleteMultiplayerRoom(exitMultiplayerRoomBody: ExitMultiplayerRoomBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiDeleteMultiplayerRoom(exitMultiplayerRoomBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiDeleteMultiplayerRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiDeleteQuestion(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiDeleteQuestion(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiDeleteQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiDeleteUserSkillHierarchy(skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiDeleteUserSkillHierarchy(skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiDeleteUserSkillHierarchy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiEndMultiplayerGameByHost(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiEndMultiplayerGameByHost(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiEndMultiplayerGameByHost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiEscapeHtmlCharacters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiEscapeHtmlCharacters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiEscapeHtmlCharacters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ExitMultiplayerRoomBody} exitMultiplayerRoomBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiExitMultiplayerRoom(exitMultiplayerRoomBody: ExitMultiplayerRoomBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiExitMultiplayerRoom(exitMultiplayerRoomBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiExitMultiplayerRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {GeneratePromptCurriculumBody} generatePromptCurriculumBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGeneratePromptCurriculum(roomId: string, generatePromptCurriculumBody: GeneratePromptCurriculumBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GeneratePromptCurriculumResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGeneratePromptCurriculum(roomId, generatePromptCurriculumBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGeneratePromptCurriculum']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {number} [duplicateCutoff] 
         * @param {boolean} [includeNoQuestionsSkills] 
         * @param {boolean} [showDuplicate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetAdminSkillTree(skillId: string, duplicateCutoff?: number, includeNoQuestionsSkills?: boolean, showDuplicate?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminSkillTreeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetAdminSkillTree(skillId, duplicateCutoff, includeNoQuestionsSkills, showDuplicate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetAdminSkillTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The AI-invite settings with what they produce right now (a dry run).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetAiMultiplayerInviteSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiInviteSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetAiMultiplayerInviteSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetAiMultiplayerInviteSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetAiQuestionGenerationStatus(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIGenerationTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetAiQuestionGenerationStatus(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetAiQuestionGenerationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetAllAiGenerationTasks(page?: string, pageSize?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AIGenerationTaskListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetAllAiGenerationTasks(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetAllAiGenerationTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} attemptId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetAnsweredAttemptById(attemptId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAttemptByIdResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetAnsweredAttemptById(attemptId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetAnsweredAttemptById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {boolean} [newestFirst] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [skillId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetAnsweredQuestionHistoryList(competitionId?: string, newestFirst?: boolean, page?: string, pageSize?: string, skillId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetAnsweredQuestionHistoryList(competitionId, newestFirst, page, pageSize, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetAnsweredQuestionHistoryList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [competitionId] 
         * @param {string} [examId] 
         * @param {string} [filterType] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [searchString] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetAnsweredQuestionList(competitionId?: string, examId?: string, filterType?: string, page?: number, pageSize?: number, searchString?: string, skillIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnsweredQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetAnsweredQuestionList(competitionId, examId, filterType, page, pageSize, searchString, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetAnsweredQuestionList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetBlockedRoomUsers(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBlockedUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetBlockedRoomUsers(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetBlockedRoomUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {number} [totalPages] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetJoinedMultiplayerRooms(page?: number, pageSize?: number, totalPages?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMultiplayerGamesListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetJoinedMultiplayerRooms(page, pageSize, totalPages, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetJoinedMultiplayerRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetMultiplayerGameHistory(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerGameHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetMultiplayerGameHistory(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetMultiplayerGameHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetMultiplayerGameInfo(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerRoomGameInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetMultiplayerGameInfo(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetMultiplayerGameInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetMultiplayerReadyUsers(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerReadyUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetMultiplayerReadyUsers(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetMultiplayerReadyUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {boolean} [activeGameUsers] 
         * @param {boolean} [entering] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetMultiplayerRoomInfo(roomId: string, activeGameUsers?: boolean, entering?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderGetMultiplayerRoomDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetMultiplayerRoomInfo(roomId, activeGameUsers, entering, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetMultiplayerRoomInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetMultiplayerSessionHistory(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerSessionHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetMultiplayerSessionHistory(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetMultiplayerSessionHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetMultiplayerStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetMultiplayerStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetMultiplayerStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [roomId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetPastPrompts(roomId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PastPromptsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetPastPrompts(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetPastPrompts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetPublicMultiplayerRoomInfo(roomCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillBuilderGetMultiplayerRoomDetailsPublicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetPublicMultiplayerRoomInfo(roomCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetPublicMultiplayerRoomInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionAiAssistantChats(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuestionAIAssistantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionAiAssistantChats(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionAiAssistantChats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionAttemptData(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttemptInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionAttemptData(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionAttemptData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {string} [subQuestions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionById(questionId: string, subQuestions?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionById(questionId, subQuestions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionExplanation(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionExplanationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionExplanation(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionExplanation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionHint(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuestionHintResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionHint(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionHint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionReviewData(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionAIReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionReviewData(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionReviewData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionSkillHierarchies(ids?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionSkillHierarchyList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionSkillHierarchies(ids, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionSkillHierarchies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionStatistics(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetQuestionStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionStatistics(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [duplicate] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {string} [questionStatus] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {string} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetQuestionUnderreviewList(duplicate?: string, page?: string, pageSize?: string, questionStatus?: string, sortBy?: string, sortOrder?: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUnderReviewQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetQuestionUnderreviewList(duplicate, page, pageSize, questionStatus, sortBy, sortOrder, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetQuestionUnderreviewList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetRoomPastPrompts(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PastPromptsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetRoomPastPrompts(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetRoomPastPrompts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetSessionProgressMetrics(sessionId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSessionEndRespons>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetSessionProgressMetrics(sessionId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetSessionProgressMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetSimilarQuestions(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimilarQuestionsList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetSimilarQuestions(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetSimilarQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {boolean} [includeNoQuestionsSkills] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetSkillTree(skillId: string, includeNoQuestionsSkills?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSkillTreeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetSkillTree(skillId, includeNoQuestionsSkills, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetSkillTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetSolution(questionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSolutionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetSolution(questionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetSolution']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UnansweredSkillQuestionBody} unansweredSkillQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetUnansweredQuestionBySkill(unansweredSkillQuestionBody: UnansweredSkillQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnansweredQuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetUnansweredQuestionBySkill(unansweredSkillQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetUnansweredQuestionBySkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetUnansweredQuestionSkillBuilder(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnansweredQuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetUnansweredQuestionSkillBuilder(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetUnansweredQuestionSkillBuilder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [isArchived] 
         * @param {boolean} [isTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetUserGoal(isArchived?: boolean, isTemplate?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetUserGoal(isArchived, isTemplate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetUserGoal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} goalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetUserGoalById(goalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetUserGoalById(goalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetUserGoalById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiGetUserSkillMilestone(sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSkillMilestoneResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiGetUserSkillMilestone(sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiGetUserSkillMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {HostTransferBody} hostTransferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiHandleHostTransferRequest(roomId: string, hostTransferBody: HostTransferBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiHandleHostTransferRequest(roomId, hostTransferBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiHandleHostTransferRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiHandleInactiveGame(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiHandleInactiveGame(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiHandleInactiveGame']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiHandleInactiveHostTransfer(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiHandleInactiveHostTransfer(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiHandleInactiveHostTransfer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {HostTransferBody} hostTransferBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiHandleMultiplayerGameEnd(roomId: string, hostTransferBody: HostTransferBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiHandleMultiplayerGameEnd(roomId, hostTransferBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiHandleMultiplayerGameEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerGameInitializeBody} multiplayerGameInitializeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiInitializeMultiplayerGame(roomId: string, multiplayerGameInitializeBody: MultiplayerGameInitializeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerGameInitializeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiInitializeMultiplayerGame(roomId, multiplayerGameInitializeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiInitializeMultiplayerGame']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerInviteUsersBody} multiplayerInviteUsersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiInviteToMultiplayerRoom(roomId: string, multiplayerInviteUsersBody: MultiplayerInviteUsersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerInviteUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiInviteToMultiplayerRoom(roomId, multiplayerInviteUsersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiInviteToMultiplayerRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiLeaveMultiplayerRoom(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiLeaveMultiplayerRoom(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiLeaveMultiplayerRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary The AI opponent roster, with how each character has actually been playing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiListMultiplayerPersonas(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPersonaListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiListMultiplayerPersonas(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiListMultiplayerPersonas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {string | null} [gameId] 
         * @param {string} [resultType] 
         * @param {string | null} [sessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiMultiplayerLeaderboard(roomId: string, gameId?: string | null, resultType?: string, sessionId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerLeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiMultiplayerLeaderboard(roomId, gameId, resultType, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiMultiplayerLeaderboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiMultiplayerReadyForNextSession(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerReadyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiMultiplayerReadyForNextSession(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiMultiplayerReadyForNextSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiMultiplayerRoomLeaderboard(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerRoomLeaderboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiMultiplayerRoomLeaderboard(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiMultiplayerRoomLeaderboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MultiplayerMuteInviterBody} multiplayerMuteInviterBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiMuteMultiplayerInviter(multiplayerMuteInviterBody: MultiplayerMuteInviterBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerMuteInviterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiMuteMultiplayerInviter(multiplayerMuteInviterBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiMuteMultiplayerInviter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {MultiplayerNudgeUserBody} multiplayerNudgeUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiNudgeMulplayerUser(gameId: string, roomId: string, multiplayerNudgeUserBody: MultiplayerNudgeUserBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiNudgeMulplayerUser(gameId, roomId, multiplayerNudgeUserBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiNudgeMulplayerUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerNudgeUserBody} multiplayerNudgeUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiNudgeMulplayerUserInRoom(roomId: string, multiplayerNudgeUserBody: MultiplayerNudgeUserBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiNudgeMulplayerUserInRoom(roomId, multiplayerNudgeUserBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiNudgeMulplayerUserInRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiPopulateQuestionMetadata(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiPopulateQuestionMetadata(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiPopulateQuestionMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillID} skillID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiPopulateQuestionSimilarityEmbeddings(skillID: SkillID, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiPopulateQuestionSimilarityEmbeddings(skillID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiPopulateQuestionSimilarityEmbeddings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {MultiplayerQuestionsGenerationBody} multiplayerQuestionsGenerationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiPromptBasedQuestionsGeneration(gameId: string, roomId: string, multiplayerQuestionsGenerationBody: MultiplayerQuestionsGenerationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiPromptBasedQuestionsGeneration(gameId, roomId, multiplayerQuestionsGenerationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiPromptBasedQuestionsGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {QuestionAIAssistantBody} questionAIAssistantBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiQuestionAiAssistant(questionId: string, questionAIAssistantBody: QuestionAIAssistantBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionAIAssistantResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiQuestionAiAssistant(questionId, questionAIAssistantBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiQuestionAiAssistant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiQuestionCreateMilestone(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionCreationMilestoneResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiQuestionCreateMilestone(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiQuestionCreateMilestone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {LikeDislikeQuestionBody} likeDislikeQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiQuestionLike(questionId: string, likeDislikeQuestionBody: LikeDislikeQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LikeDislikeQuestionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiQuestionLike(questionId, likeDislikeQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiQuestionLike']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<QuestionPublicAttemptBody>} questionPublicAttemptBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiQuestionPublicAttempt(questionPublicAttemptBody: Array<QuestionPublicAttemptBody>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionPublicAttemptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiQuestionPublicAttempt(questionPublicAttemptBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiQuestionPublicAttempt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * enough real attempts from its correct rate. Runs async on the worker; optional `skill_ids` in the JSON body scope it to questions in those skills.
         * @summary Kick off the statistical difficulty recompute: re-levels every question with
         * @param {RecomputeDifficultyBody} recomputeDifficultyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiRecomputeQuestionDifficulty(recomputeDifficultyBody: RecomputeDifficultyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiRecomputeQuestionDifficulty(recomputeDifficultyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiRecomputeQuestionDifficulty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiRecordMultiplayerInviteClick(inviteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiRecordMultiplayerInviteClick(inviteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiRecordMultiplayerInviteClick']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerRemoveOrBlockUserBody} multiplayerRemoveOrBlockUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiRemoveOrBlockMultiplayerUser(roomId: string, multiplayerRemoveOrBlockUserBody: MultiplayerRemoveOrBlockUserBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiRemoveOrBlockMultiplayerUser(roomId, multiplayerRemoveOrBlockUserBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiRemoveOrBlockMultiplayerUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiReplaceExternalImagesApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiReplaceExternalImagesApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiReplaceExternalImagesApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiReplaceExternalTextsApi(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiReplaceExternalTextsApi(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiReplaceExternalTextsApi']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiRequestHostChange(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiRequestHostChange(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiRequestHostChange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiRequestMultiplayerGameEnd(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiRequestMultiplayerGameEnd(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiRequestMultiplayerGameEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RescaleQuestionEmbeddingDimensions} rescaleQuestionEmbeddingDimensions 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiRescaleQuestionEmbeddingDimensions(rescaleQuestionEmbeddingDimensions: RescaleQuestionEmbeddingDimensions, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RescaleQuestionEmbeddingDimensionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiRescaleQuestionEmbeddingDimensions(rescaleQuestionEmbeddingDimensions, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiRescaleQuestionEmbeddingDimensions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchId 
         * @param {RespondAiInviteBody} respondAiInviteBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiRespondAiMultiplayerInvite(batchId: string, respondAiInviteBody: RespondAiInviteBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiRespondAiMultiplayerInvite(batchId, respondAiInviteBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiRespondAiMultiplayerInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary One tick now, ignoring the send frequency. Sends only if sending is on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiRunAiMultiplayerInvitesNow(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiInviteRunNowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiRunAiMultiplayerInvitesNow(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiRunAiMultiplayerInvitesNow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiScheduleMultiplayerOfflineInvites(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerOfflineInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiScheduleMultiplayerOfflineInvites(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiScheduleMultiplayerOfflineInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {MultiplayerReactionBody} multiplayerReactionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSendMultiplayerReaction(gameId: string, roomId: string, multiplayerReactionBody: MultiplayerReactionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessMsg>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSendMultiplayerReaction(gameId, roomId, multiplayerReactionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSendMultiplayerReaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {MultiplayerInvitePreferenceBody} multiplayerInvitePreferenceBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSetMultiplayerInvitePreference(multiplayerInvitePreferenceBody: MultiplayerInvitePreferenceBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerInvitePreferenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSetMultiplayerInvitePreference(multiplayerInvitePreferenceBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSetMultiplayerInvitePreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillBuilderMultiplayerHostSessionParam} skillBuilderMultiplayerHostSessionParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSkillBuilderMultiplayerHost(skillBuilderMultiplayerHostSessionParam: SkillBuilderMultiplayerHostSessionParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMultiplayerGamesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSkillBuilderMultiplayerHost(skillBuilderMultiplayerHostSessionParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSkillBuilderMultiplayerHost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SkillBuilderMultiplayerJoinSessionParam} skillBuilderMultiplayerJoinSessionParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSkillBuilderMultiplayerJoin(skillBuilderMultiplayerJoinSessionParam: SkillBuilderMultiplayerJoinSessionParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMultiplayerGamesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSkillBuilderMultiplayerJoin(skillBuilderMultiplayerJoinSessionParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSkillBuilderMultiplayerJoin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {string} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSkillBuilderMultiplayerSessionProgress(roomId: string, sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerSessionProgressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSkillBuilderMultiplayerSessionProgress(roomId, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSkillBuilderMultiplayerSessionProgress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSkillBuilderMultiplayerSessionStartStatistics(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerSessionStartStatisticsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSkillBuilderMultiplayerSessionStartStatistics(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSkillBuilderMultiplayerSessionStartStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSkillBuilderMultiplayerStartSession(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerSessionResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSkillBuilderMultiplayerStartSession(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSkillBuilderMultiplayerStartSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSkillBuilderMultiplayerStartWithPersona(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerStartWithPersonaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSkillBuilderMultiplayerStartWithPersona(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSkillBuilderMultiplayerStartWithPersona']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sessionId 
         * @param {string} skillId 
         * @param {UserSessionEndParam} userSessionEndParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSkillBuilderSessionEnd(sessionId: string, skillId: string, userSessionEndParam: UserSessionEndParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSessionEndRespons>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSkillBuilderSessionEnd(sessionId, skillId, userSessionEndParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSkillBuilderSessionEnd']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {NestedSkillID} nestedSkillID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSkillBuilderSessionStart(skillId: string, nestedSkillID: NestedSkillID, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SkillStartSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSkillBuilderSessionStart(skillId, nestedSkillID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSkillBuilderSessionStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {SolutionRatingBody} solutionRatingBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiSolutionRating(questionId: string, solutionRatingBody: SolutionRatingBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SolutionRatingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiSolutionRating(questionId, solutionRatingBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiSolutionRating']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiStopAiQuestionGeneration(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiStopAiQuestionGeneration(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiStopAiQuestionGeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {TransferRoomAdminBody} transferRoomAdminBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiTransferRoomAdmin(roomId: string, transferRoomAdminBody: TransferRoomAdminBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferRoomAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiTransferRoomAdmin(roomId, transferRoomAdminBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiTransferRoomAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {UnblockMultiplayerUserBody} unblockMultiplayerUserBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUnblockMultiplayerUser(roomId: string, unblockMultiplayerUserBody: UnblockMultiplayerUserBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUnblockMultiplayerUser(roomId, unblockMultiplayerUserBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUnblockMultiplayerUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AiInviteSettingUpdateBody} aiInviteSettingUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateAiMultiplayerInviteSetting(aiInviteSettingUpdateBody: AiInviteSettingUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiInviteSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateAiMultiplayerInviteSetting(aiInviteSettingUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateAiMultiplayerInviteSetting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateBookmarkCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateBookmarkCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateBookmarkCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * a delete would take the opponent off past players\' result screens.
         * @summary Rename, re-skin, re-band or retire a character. Retiring is is_active=False —
         * @param {string} personaId 
         * @param {AdminPersonaUpdateBody} adminPersonaUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateMultiplayerPersona(personaId: string, adminPersonaUpdateBody: AdminPersonaUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateMultiplayerPersona(personaId, adminPersonaUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateMultiplayerPersona']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerPromptUpdateBody} multiplayerPromptUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateMultiplayerPromptText(roomId: string, multiplayerPromptUpdateBody: MultiplayerPromptUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerPromptUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateMultiplayerPromptText(roomId, multiplayerPromptUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateMultiplayerPromptText']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {MultiplayerRoomNameUpdateBody} multiplayerRoomNameUpdateBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateMultiplayerRoomName(roomId: string, multiplayerRoomNameUpdateBody: MultiplayerRoomNameUpdateBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateMultiplayerRoomName(roomId, multiplayerRoomNameUpdateBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateMultiplayerRoomName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} roomId 
         * @param {string} skillId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateMultiplayerSkill(roomId: string, skillId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerSkillUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateMultiplayerSkill(roomId, skillId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateMultiplayerSkill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateOptionBody} updateOptionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateOption(updateOptionBody: UpdateOptionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateOption(updateOptionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateOption']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateQuestionBody} updateQuestionBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateQuestion(questionId: string, updateQuestionBody: UpdateQuestionBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionResponseSchemaSkillDict>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateQuestion(questionId, updateQuestionBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UpdateUnderReviewBody} updateUnderReviewBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateUnderReviewDetails(questionId: string, updateUnderReviewBody: UpdateUnderReviewBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateUnderReviewDetails(questionId, updateUnderReviewBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateUnderReviewDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BulkUpdateUnderReviewStatusParam} bulkUpdateUnderReviewStatusParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateUnderReviewDetailsBulk(bulkUpdateUnderReviewStatusParam: BulkUpdateUnderReviewStatusParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateUnderReviewDetailsBulk(bulkUpdateUnderReviewStatusParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateUnderReviewDetailsBulk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} goalId 
         * @param {UpdateUserGoalBody} updateUserGoalBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpdateUserGoal(goalId: string, updateUserGoalBody: UpdateUserGoalBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserGoalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpdateUserGoal(goalId, updateUserGoalBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpdateUserGoal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} questionId 
         * @param {UserQuestionFeedbackParam} userQuestionFeedbackParam 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpsertUserQuestionFeedback(questionId: string, userQuestionFeedbackParam: UserQuestionFeedbackParam, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpsertUserQuestionFeedback(questionId, userQuestionFeedbackParam, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpsertUserQuestionFeedback']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} skillId 
         * @param {UpsertUserSkillTreeBody} upsertUserSkillTreeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiUpsertUserSkillTree(skillId: string, upsertUserSkillTreeBody: UpsertUserSkillTreeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiUpsertUserSkillTree(skillId, upsertUserSkillTreeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiUpsertUserSkillTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gameId 
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async questionApiWidenMultiplayerSkillSearch(gameId: string, roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MultiplayerWidenSkillSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.questionApiWidenMultiplayerSkillSearch(gameId, roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionApiApi.questionApiWidenMultiplayerSkillSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionApiApi - factory interface
 */
export const QuestionApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionApiApiFp(configuration)
    return {
        /**
         * 
         * @param {QuestionApiApiQuestionApiAcceptAiMultiplayerInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAcceptAiMultiplayerInvite(requestParameters: QuestionApiApiQuestionApiAcceptAiMultiplayerInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AcceptAiInviteResponse> {
            return localVarFp.questionApiAcceptAiMultiplayerInvite(requestParameters.batchId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAdminCreateUserGoalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAdminCreateUserGoal(requestParameters: QuestionApiApiQuestionApiAdminCreateUserGoalRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserGoalResponse> {
            return localVarFp.questionApiAdminCreateUserGoal(requestParameters.adminCreateUserGoalBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAdminUpdateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAdminUpdateQuestion(requestParameters: QuestionApiApiQuestionApiAdminUpdateQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionResponseSchemaSkillDict> {
            return localVarFp.questionApiAdminUpdateQuestion(requestParameters.questionId, requestParameters.updateQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAiAssistantFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAiAssistantFeedback(requestParameters: QuestionApiApiQuestionApiAiAssistantFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiAiAssistantFeedback(requestParameters.chatId, requestParameters.questionId, requestParameters.aIAssistantFeedbackBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAiEnhanceQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAiEnhanceQuestion(requestParameters: QuestionApiApiQuestionApiAiEnhanceQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiAiEnhanceQuestion(requestParameters.questionId, requestParameters.aIEnhanceQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAiHierarchyQuestionGenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAiHierarchyQuestionGeneration(requestParameters: QuestionApiApiQuestionApiAiHierarchyQuestionGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiAiHierarchyQuestionGeneration(requestParameters.aIHierarchyQuestionGenerationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAiSelfQuestionGenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAiSelfQuestionGeneration(requestParameters: QuestionApiApiQuestionApiAiSelfQuestionGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiAiSelfQuestionGeneration(requestParameters.aIQuestionGenerationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiApplyAiEnhanceQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiApplyAiEnhanceQuestion(requestParameters: QuestionApiApiQuestionApiApplyAiEnhanceQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApplyAIEnhanceResponse> {
            return localVarFp.questionApiApplyAiEnhanceQuestion(requestParameters.questionId, requestParameters.applyAIEnhanceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAttemptMultiplayerQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAttemptMultiplayerQuestion(requestParameters: QuestionApiApiQuestionApiAttemptMultiplayerQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerAttemptQuestionResponse> {
            return localVarFp.questionApiAttemptMultiplayerQuestion(requestParameters.questionId, requestParameters.roomId, requestParameters.attemptQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAttemptQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAttemptQuestion(requestParameters: QuestionApiApiQuestionApiAttemptQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttemptQuestionResponse> {
            return localVarFp.questionApiAttemptQuestion(requestParameters.questionId, requestParameters.sessionId, requestParameters.attemptQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiAttemptQuestionByCompetitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiAttemptQuestionByCompetition(requestParameters: QuestionApiApiQuestionApiAttemptQuestionByCompetitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttemptQuestionCompetitionResponse> {
            return localVarFp.questionApiAttemptQuestionByCompetition(requestParameters.competitionId, requestParameters.questionId, requestParameters.attemptQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiBookmarkQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiBookmarkQuestion(requestParameters: QuestionApiApiQuestionApiBookmarkQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiBookmarkQuestion(requestParameters.questionId, requestParameters.bookmarkQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiBulkActionsReviewQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiBulkActionsReviewQuestions(requestParameters: QuestionApiApiQuestionApiBulkActionsReviewQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<BulkActionsReviewQuestionBodyResponse> {
            return localVarFp.questionApiBulkActionsReviewQuestions(requestParameters.bulkActionsReviewQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiBulkBlockDuplicatesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiBulkBlockDuplicates(requestParameters: QuestionApiApiQuestionApiBulkBlockDuplicatesRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessData> {
            return localVarFp.questionApiBulkBlockDuplicates(requestParameters.duplicateQuestion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiCheckAndGeneratePromptQuestionsAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCheckAndGeneratePromptQuestionsAvailability(requestParameters: QuestionApiApiQuestionApiCheckAndGeneratePromptQuestionsAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.questionApiCheckAndGeneratePromptQuestionsAvailability(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiCreateMultiplayerPersonaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCreateMultiplayerPersona(requestParameters: QuestionApiApiQuestionApiCreateMultiplayerPersonaRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPersonaCreateResponse> {
            return localVarFp.questionApiCreateMultiplayerPersona(requestParameters.adminPersonaCreateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiCreateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCreateQuestion(requestParameters: QuestionApiApiQuestionApiCreateQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionResponseSchemaSkillDict> {
            return localVarFp.questionApiCreateQuestion(requestParameters.createQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiCreateSlugTestapiRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCreateSlugTestapi(requestParameters: QuestionApiApiQuestionApiCreateSlugTestapiRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiCreateSlugTestapi(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiCreateUserGoalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiCreateUserGoal(requestParameters: QuestionApiApiQuestionApiCreateUserGoalRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserGoalResponse> {
            return localVarFp.questionApiCreateUserGoal(requestParameters.createUserGoalBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiDeleteBlockedQuestionApi(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.questionApiDeleteBlockedQuestionApi(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiDeleteMultiplayerRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiDeleteMultiplayerRoom(requestParameters: QuestionApiApiQuestionApiDeleteMultiplayerRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.questionApiDeleteMultiplayerRoom(requestParameters.exitMultiplayerRoomBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiDeleteQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiDeleteQuestion(requestParameters: QuestionApiApiQuestionApiDeleteQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiDeleteQuestion(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiDeleteUserSkillHierarchyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiDeleteUserSkillHierarchy(requestParameters: QuestionApiApiQuestionApiDeleteUserSkillHierarchyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiDeleteUserSkillHierarchy(requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiEndMultiplayerGameByHostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiEndMultiplayerGameByHost(requestParameters: QuestionApiApiQuestionApiEndMultiplayerGameByHostRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiEndMultiplayerGameByHost(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiEscapeHtmlCharacters(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.questionApiEscapeHtmlCharacters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiExitMultiplayerRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiExitMultiplayerRoom(requestParameters: QuestionApiApiQuestionApiExitMultiplayerRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.questionApiExitMultiplayerRoom(requestParameters.exitMultiplayerRoomBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGeneratePromptCurriculumRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGeneratePromptCurriculum(requestParameters: QuestionApiApiQuestionApiGeneratePromptCurriculumRequest, options?: RawAxiosRequestConfig): AxiosPromise<GeneratePromptCurriculumResponse> {
            return localVarFp.questionApiGeneratePromptCurriculum(requestParameters.roomId, requestParameters.generatePromptCurriculumBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetAdminSkillTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAdminSkillTree(requestParameters: QuestionApiApiQuestionApiGetAdminSkillTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminSkillTreeResponse> {
            return localVarFp.questionApiGetAdminSkillTree(requestParameters.skillId, requestParameters.duplicateCutoff, requestParameters.includeNoQuestionsSkills, requestParameters.showDuplicate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The AI-invite settings with what they produce right now (a dry run).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAiMultiplayerInviteSettings(options?: RawAxiosRequestConfig): AxiosPromise<AiInviteSettingsResponse> {
            return localVarFp.questionApiGetAiMultiplayerInviteSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetAiQuestionGenerationStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAiQuestionGenerationStatus(requestParameters: QuestionApiApiQuestionApiGetAiQuestionGenerationStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AIGenerationTaskResponse> {
            return localVarFp.questionApiGetAiQuestionGenerationStatus(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetAllAiGenerationTasksRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAllAiGenerationTasks(requestParameters: QuestionApiApiQuestionApiGetAllAiGenerationTasksRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AIGenerationTaskListResponse> {
            return localVarFp.questionApiGetAllAiGenerationTasks(requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetAnsweredAttemptByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAnsweredAttemptById(requestParameters: QuestionApiApiQuestionApiGetAnsweredAttemptByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAttemptByIdResponse> {
            return localVarFp.questionApiGetAnsweredAttemptById(requestParameters.attemptId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetAnsweredQuestionHistoryListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAnsweredQuestionHistoryList(requestParameters: QuestionApiApiQuestionApiGetAnsweredQuestionHistoryListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AttemptHistoryResponse> {
            return localVarFp.questionApiGetAnsweredQuestionHistoryList(requestParameters.competitionId, requestParameters.newestFirst, requestParameters.page, requestParameters.pageSize, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetAnsweredQuestionListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetAnsweredQuestionList(requestParameters: QuestionApiApiQuestionApiGetAnsweredQuestionListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AnsweredQuestionResponse> {
            return localVarFp.questionApiGetAnsweredQuestionList(requestParameters.competitionId, requestParameters.examId, requestParameters.filterType, requestParameters.page, requestParameters.pageSize, requestParameters.searchString, requestParameters.skillIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetBlockedRoomUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetBlockedRoomUsers(requestParameters: QuestionApiApiQuestionApiGetBlockedRoomUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetBlockedUsersResponse> {
            return localVarFp.questionApiGetBlockedRoomUsers(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetJoinedMultiplayerRoomsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetJoinedMultiplayerRooms(requestParameters: QuestionApiApiQuestionApiGetJoinedMultiplayerRoomsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetMultiplayerGamesListResponse> {
            return localVarFp.questionApiGetJoinedMultiplayerRooms(requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetMultiplayerGameHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerGameHistory(requestParameters: QuestionApiApiQuestionApiGetMultiplayerGameHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerGameHistoryResponse> {
            return localVarFp.questionApiGetMultiplayerGameHistory(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetMultiplayerGameInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerGameInfo(requestParameters: QuestionApiApiQuestionApiGetMultiplayerGameInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerRoomGameInfoResponse> {
            return localVarFp.questionApiGetMultiplayerGameInfo(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetMultiplayerReadyUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerReadyUsers(requestParameters: QuestionApiApiQuestionApiGetMultiplayerReadyUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerReadyUsersResponse> {
            return localVarFp.questionApiGetMultiplayerReadyUsers(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetMultiplayerRoomInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerRoomInfo(requestParameters: QuestionApiApiQuestionApiGetMultiplayerRoomInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderGetMultiplayerRoomDetailsResponse> {
            return localVarFp.questionApiGetMultiplayerRoomInfo(requestParameters.roomId, requestParameters.activeGameUsers, requestParameters.entering, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetMultiplayerSessionHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerSessionHistory(requestParameters: QuestionApiApiQuestionApiGetMultiplayerSessionHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerSessionHistoryResponse> {
            return localVarFp.questionApiGetMultiplayerSessionHistory(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetMultiplayerStats(options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerStatsResponse> {
            return localVarFp.questionApiGetMultiplayerStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetPastPromptsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetPastPrompts(requestParameters: QuestionApiApiQuestionApiGetPastPromptsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PastPromptsResponse> {
            return localVarFp.questionApiGetPastPrompts(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetPublicMultiplayerRoomInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetPublicMultiplayerRoomInfo(requestParameters: QuestionApiApiQuestionApiGetPublicMultiplayerRoomInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillBuilderGetMultiplayerRoomDetailsPublicResponse> {
            return localVarFp.questionApiGetPublicMultiplayerRoomInfo(requestParameters.roomCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionAiAssistantChatsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionAiAssistantChats(requestParameters: QuestionApiApiQuestionApiGetQuestionAiAssistantChatsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuestionAIAssistantResponse> {
            return localVarFp.questionApiGetQuestionAiAssistantChats(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionAttemptDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionAttemptData(requestParameters: QuestionApiApiQuestionApiGetQuestionAttemptDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<AttemptInfoResponse> {
            return localVarFp.questionApiGetQuestionAttemptData(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionById(requestParameters: QuestionApiApiQuestionApiGetQuestionByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionResponseSchemaSkillDict> {
            return localVarFp.questionApiGetQuestionById(requestParameters.questionId, requestParameters.subQuestions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionExplanationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionExplanation(requestParameters: QuestionApiApiQuestionApiGetQuestionExplanationRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionExplanationResponse> {
            return localVarFp.questionApiGetQuestionExplanation(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionHintRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionHint(requestParameters: QuestionApiApiQuestionApiGetQuestionHintRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuestionHintResponse> {
            return localVarFp.questionApiGetQuestionHint(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionReviewDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionReviewData(requestParameters: QuestionApiApiQuestionApiGetQuestionReviewDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionAIReviewResponse> {
            return localVarFp.questionApiGetQuestionReviewData(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionSkillHierarchiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionSkillHierarchies(requestParameters: QuestionApiApiQuestionApiGetQuestionSkillHierarchiesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<QuestionSkillHierarchyList> {
            return localVarFp.questionApiGetQuestionSkillHierarchies(requestParameters.ids, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionStatistics(requestParameters: QuestionApiApiQuestionApiGetQuestionStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetQuestionStatisticsResponse> {
            return localVarFp.questionApiGetQuestionStatistics(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetQuestionUnderreviewListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetQuestionUnderreviewList(requestParameters: QuestionApiApiQuestionApiGetQuestionUnderreviewListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetUnderReviewQuestionResponse> {
            return localVarFp.questionApiGetQuestionUnderreviewList(requestParameters.duplicate, requestParameters.page, requestParameters.pageSize, requestParameters.questionStatus, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetRoomPastPromptsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetRoomPastPrompts(requestParameters: QuestionApiApiQuestionApiGetRoomPastPromptsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PastPromptsResponse> {
            return localVarFp.questionApiGetRoomPastPrompts(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetSessionProgressMetricsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetSessionProgressMetrics(requestParameters: QuestionApiApiQuestionApiGetSessionProgressMetricsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSessionEndRespons> {
            return localVarFp.questionApiGetSessionProgressMetrics(requestParameters.sessionId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetSimilarQuestionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetSimilarQuestions(requestParameters: QuestionApiApiQuestionApiGetSimilarQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SimilarQuestionsList> {
            return localVarFp.questionApiGetSimilarQuestions(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetSkillTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetSkillTree(requestParameters: QuestionApiApiQuestionApiGetSkillTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSkillTreeResponse> {
            return localVarFp.questionApiGetSkillTree(requestParameters.skillId, requestParameters.includeNoQuestionsSkills, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetSolutionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetSolution(requestParameters: QuestionApiApiQuestionApiGetSolutionRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetSolutionResponse> {
            return localVarFp.questionApiGetSolution(requestParameters.questionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetUnansweredQuestionBySkillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUnansweredQuestionBySkill(requestParameters: QuestionApiApiQuestionApiGetUnansweredQuestionBySkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnansweredQuestionResponseSchemaSkillDict> {
            return localVarFp.questionApiGetUnansweredQuestionBySkill(requestParameters.unansweredSkillQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetUnansweredQuestionSkillBuilderRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUnansweredQuestionSkillBuilder(requestParameters: QuestionApiApiQuestionApiGetUnansweredQuestionSkillBuilderRequest, options?: RawAxiosRequestConfig): AxiosPromise<UnansweredQuestionResponseSchemaSkillDict> {
            return localVarFp.questionApiGetUnansweredQuestionSkillBuilder(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetUserGoalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUserGoal(requestParameters: QuestionApiApiQuestionApiGetUserGoalRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetUserGoalResponse> {
            return localVarFp.questionApiGetUserGoal(requestParameters.isArchived, requestParameters.isTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetUserGoalByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUserGoalById(requestParameters: QuestionApiApiQuestionApiGetUserGoalByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserGoalResponse> {
            return localVarFp.questionApiGetUserGoalById(requestParameters.goalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiGetUserSkillMilestoneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiGetUserSkillMilestone(requestParameters: QuestionApiApiQuestionApiGetUserSkillMilestoneRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSkillMilestoneResponse> {
            return localVarFp.questionApiGetUserSkillMilestone(requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiHandleHostTransferRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiHandleHostTransferRequest(requestParameters: QuestionApiApiQuestionApiHandleHostTransferRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiHandleHostTransferRequest(requestParameters.roomId, requestParameters.hostTransferBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiHandleInactiveGameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiHandleInactiveGame(requestParameters: QuestionApiApiQuestionApiHandleInactiveGameRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiHandleInactiveGame(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiHandleInactiveHostTransferRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiHandleInactiveHostTransfer(requestParameters: QuestionApiApiQuestionApiHandleInactiveHostTransferRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiHandleInactiveHostTransfer(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiHandleMultiplayerGameEndRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiHandleMultiplayerGameEnd(requestParameters: QuestionApiApiQuestionApiHandleMultiplayerGameEndRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiHandleMultiplayerGameEnd(requestParameters.roomId, requestParameters.hostTransferBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiInitializeMultiplayerGameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiInitializeMultiplayerGame(requestParameters: QuestionApiApiQuestionApiInitializeMultiplayerGameRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerGameInitializeResponse> {
            return localVarFp.questionApiInitializeMultiplayerGame(requestParameters.roomId, requestParameters.multiplayerGameInitializeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiInviteToMultiplayerRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiInviteToMultiplayerRoom(requestParameters: QuestionApiApiQuestionApiInviteToMultiplayerRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerInviteUsersResponse> {
            return localVarFp.questionApiInviteToMultiplayerRoom(requestParameters.roomId, requestParameters.multiplayerInviteUsersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiLeaveMultiplayerRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiLeaveMultiplayerRoom(requestParameters: QuestionApiApiQuestionApiLeaveMultiplayerRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiLeaveMultiplayerRoom(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The AI opponent roster, with how each character has actually been playing.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiListMultiplayerPersonas(options?: RawAxiosRequestConfig): AxiosPromise<AdminPersonaListResponse> {
            return localVarFp.questionApiListMultiplayerPersonas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiMultiplayerLeaderboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiMultiplayerLeaderboard(requestParameters: QuestionApiApiQuestionApiMultiplayerLeaderboardRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerLeaderboardResponse> {
            return localVarFp.questionApiMultiplayerLeaderboard(requestParameters.roomId, requestParameters.gameId, requestParameters.resultType, requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiMultiplayerReadyForNextSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiMultiplayerReadyForNextSession(requestParameters: QuestionApiApiQuestionApiMultiplayerReadyForNextSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerReadyResponse> {
            return localVarFp.questionApiMultiplayerReadyForNextSession(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiMultiplayerRoomLeaderboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiMultiplayerRoomLeaderboard(requestParameters: QuestionApiApiQuestionApiMultiplayerRoomLeaderboardRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerRoomLeaderboardResponse> {
            return localVarFp.questionApiMultiplayerRoomLeaderboard(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiMuteMultiplayerInviterRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiMuteMultiplayerInviter(requestParameters: QuestionApiApiQuestionApiMuteMultiplayerInviterRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerMuteInviterResponse> {
            return localVarFp.questionApiMuteMultiplayerInviter(requestParameters.multiplayerMuteInviterBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiNudgeMulplayerUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiNudgeMulplayerUser(requestParameters: QuestionApiApiQuestionApiNudgeMulplayerUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.questionApiNudgeMulplayerUser(requestParameters.gameId, requestParameters.roomId, requestParameters.multiplayerNudgeUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiNudgeMulplayerUserInRoomRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiNudgeMulplayerUserInRoom(requestParameters: QuestionApiApiQuestionApiNudgeMulplayerUserInRoomRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.questionApiNudgeMulplayerUserInRoom(requestParameters.roomId, requestParameters.multiplayerNudgeUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiPopulateQuestionMetadata(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiPopulateQuestionMetadata(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiPopulateQuestionSimilarityEmbeddingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiPopulateQuestionSimilarityEmbeddings(requestParameters: QuestionApiApiQuestionApiPopulateQuestionSimilarityEmbeddingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiPopulateQuestionSimilarityEmbeddings(requestParameters.skillID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiPromptBasedQuestionsGenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiPromptBasedQuestionsGeneration(requestParameters: QuestionApiApiQuestionApiPromptBasedQuestionsGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiPromptBasedQuestionsGeneration(requestParameters.gameId, requestParameters.roomId, requestParameters.multiplayerQuestionsGenerationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiQuestionAiAssistantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiQuestionAiAssistant(requestParameters: QuestionApiApiQuestionApiQuestionAiAssistantRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionAIAssistantResponse> {
            return localVarFp.questionApiQuestionAiAssistant(requestParameters.questionId, requestParameters.questionAIAssistantBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiQuestionCreateMilestone(options?: RawAxiosRequestConfig): AxiosPromise<QuestionCreationMilestoneResponse> {
            return localVarFp.questionApiQuestionCreateMilestone(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiQuestionLikeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiQuestionLike(requestParameters: QuestionApiApiQuestionApiQuestionLikeRequest, options?: RawAxiosRequestConfig): AxiosPromise<LikeDislikeQuestionResponse> {
            return localVarFp.questionApiQuestionLike(requestParameters.questionId, requestParameters.likeDislikeQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiQuestionPublicAttemptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiQuestionPublicAttempt(requestParameters: QuestionApiApiQuestionApiQuestionPublicAttemptRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionPublicAttemptResponse> {
            return localVarFp.questionApiQuestionPublicAttempt(requestParameters.questionPublicAttemptBody, options).then((request) => request(axios, basePath));
        },
        /**
         * enough real attempts from its correct rate. Runs async on the worker; optional `skill_ids` in the JSON body scope it to questions in those skills.
         * @summary Kick off the statistical difficulty recompute: re-levels every question with
         * @param {QuestionApiApiQuestionApiRecomputeQuestionDifficultyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRecomputeQuestionDifficulty(requestParameters: QuestionApiApiQuestionApiRecomputeQuestionDifficultyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessData> {
            return localVarFp.questionApiRecomputeQuestionDifficulty(requestParameters.recomputeDifficultyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiRecordMultiplayerInviteClickRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRecordMultiplayerInviteClick(requestParameters: QuestionApiApiQuestionApiRecordMultiplayerInviteClickRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiRecordMultiplayerInviteClick(requestParameters.inviteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiRemoveOrBlockMultiplayerUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRemoveOrBlockMultiplayerUser(requestParameters: QuestionApiApiQuestionApiRemoveOrBlockMultiplayerUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiRemoveOrBlockMultiplayerUser(requestParameters.roomId, requestParameters.multiplayerRemoveOrBlockUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiReplaceExternalImagesApi(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.questionApiReplaceExternalImagesApi(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiReplaceExternalTextsApi(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.questionApiReplaceExternalTextsApi(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiRequestHostChangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRequestHostChange(requestParameters: QuestionApiApiQuestionApiRequestHostChangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.questionApiRequestHostChange(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiRequestMultiplayerGameEndRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRequestMultiplayerGameEnd(requestParameters: QuestionApiApiQuestionApiRequestMultiplayerGameEndRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.questionApiRequestMultiplayerGameEnd(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiRescaleQuestionEmbeddingDimensionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRescaleQuestionEmbeddingDimensions(requestParameters: QuestionApiApiQuestionApiRescaleQuestionEmbeddingDimensionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RescaleQuestionEmbeddingDimensionsResponse> {
            return localVarFp.questionApiRescaleQuestionEmbeddingDimensions(requestParameters.rescaleQuestionEmbeddingDimensions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiRespondAiMultiplayerInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRespondAiMultiplayerInvite(requestParameters: QuestionApiApiQuestionApiRespondAiMultiplayerInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiRespondAiMultiplayerInvite(requestParameters.batchId, requestParameters.respondAiInviteBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary One tick now, ignoring the send frequency. Sends only if sending is on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiRunAiMultiplayerInvitesNow(options?: RawAxiosRequestConfig): AxiosPromise<AiInviteRunNowResponse> {
            return localVarFp.questionApiRunAiMultiplayerInvitesNow(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiScheduleMultiplayerOfflineInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiScheduleMultiplayerOfflineInvites(requestParameters: QuestionApiApiQuestionApiScheduleMultiplayerOfflineInvitesRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerOfflineInviteResponse> {
            return localVarFp.questionApiScheduleMultiplayerOfflineInvites(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSendMultiplayerReactionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSendMultiplayerReaction(requestParameters: QuestionApiApiQuestionApiSendMultiplayerReactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessMsg> {
            return localVarFp.questionApiSendMultiplayerReaction(requestParameters.gameId, requestParameters.roomId, requestParameters.multiplayerReactionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSetMultiplayerInvitePreferenceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSetMultiplayerInvitePreference(requestParameters: QuestionApiApiQuestionApiSetMultiplayerInvitePreferenceRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerInvitePreferenceResponse> {
            return localVarFp.questionApiSetMultiplayerInvitePreference(requestParameters.multiplayerInvitePreferenceBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerHostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerHost(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerHostRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMultiplayerGamesResponse> {
            return localVarFp.questionApiSkillBuilderMultiplayerHost(requestParameters.skillBuilderMultiplayerHostSessionParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerJoinRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerJoin(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerJoinRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetMultiplayerGamesResponse> {
            return localVarFp.questionApiSkillBuilderMultiplayerJoin(requestParameters.skillBuilderMultiplayerJoinSessionParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionProgressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerSessionProgress(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionProgressRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerSessionProgressResponse> {
            return localVarFp.questionApiSkillBuilderMultiplayerSessionProgress(requestParameters.roomId, requestParameters.sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionStartStatisticsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerSessionStartStatistics(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionStartStatisticsRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerSessionStartStatisticsResponse> {
            return localVarFp.questionApiSkillBuilderMultiplayerSessionStartStatistics(requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerStartSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerStartSession(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerStartSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerSessionResponseBase> {
            return localVarFp.questionApiSkillBuilderMultiplayerStartSession(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerStartWithPersonaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderMultiplayerStartWithPersona(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerStartWithPersonaRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerStartWithPersonaResponse> {
            return localVarFp.questionApiSkillBuilderMultiplayerStartWithPersona(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSkillBuilderSessionEndRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderSessionEnd(requestParameters: QuestionApiApiQuestionApiSkillBuilderSessionEndRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserSessionEndRespons> {
            return localVarFp.questionApiSkillBuilderSessionEnd(requestParameters.sessionId, requestParameters.skillId, requestParameters.userSessionEndParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSkillBuilderSessionStartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSkillBuilderSessionStart(requestParameters: QuestionApiApiQuestionApiSkillBuilderSessionStartRequest, options?: RawAxiosRequestConfig): AxiosPromise<SkillStartSessionResponse> {
            return localVarFp.questionApiSkillBuilderSessionStart(requestParameters.skillId, requestParameters.nestedSkillID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiSolutionRatingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiSolutionRating(requestParameters: QuestionApiApiQuestionApiSolutionRatingRequest, options?: RawAxiosRequestConfig): AxiosPromise<SolutionRatingResponse> {
            return localVarFp.questionApiSolutionRating(requestParameters.questionId, requestParameters.solutionRatingBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiStopAiQuestionGenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiStopAiQuestionGeneration(requestParameters: QuestionApiApiQuestionApiStopAiQuestionGenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiStopAiQuestionGeneration(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiTransferRoomAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiTransferRoomAdmin(requestParameters: QuestionApiApiQuestionApiTransferRoomAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransferRoomAdminResponse> {
            return localVarFp.questionApiTransferRoomAdmin(requestParameters.roomId, requestParameters.transferRoomAdminBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUnblockMultiplayerUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUnblockMultiplayerUser(requestParameters: QuestionApiApiQuestionApiUnblockMultiplayerUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiUnblockMultiplayerUser(requestParameters.roomId, requestParameters.unblockMultiplayerUserBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateAiMultiplayerInviteSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateAiMultiplayerInviteSetting(requestParameters: QuestionApiApiQuestionApiUpdateAiMultiplayerInviteSettingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AiInviteSettingsResponse> {
            return localVarFp.questionApiUpdateAiMultiplayerInviteSetting(requestParameters.aiInviteSettingUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateBookmarkCount(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiUpdateBookmarkCount(options).then((request) => request(axios, basePath));
        },
        /**
         * a delete would take the opponent off past players\' result screens.
         * @summary Rename, re-skin, re-band or retire a character. Retiring is is_active=False —
         * @param {QuestionApiApiQuestionApiUpdateMultiplayerPersonaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateMultiplayerPersona(requestParameters: QuestionApiApiQuestionApiUpdateMultiplayerPersonaRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiUpdateMultiplayerPersona(requestParameters.personaId, requestParameters.adminPersonaUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateMultiplayerPromptTextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateMultiplayerPromptText(requestParameters: QuestionApiApiQuestionApiUpdateMultiplayerPromptTextRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerPromptUpdateResponse> {
            return localVarFp.questionApiUpdateMultiplayerPromptText(requestParameters.roomId, requestParameters.multiplayerPromptUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateMultiplayerRoomNameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateMultiplayerRoomName(requestParameters: QuestionApiApiQuestionApiUpdateMultiplayerRoomNameRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiUpdateMultiplayerRoomName(requestParameters.roomId, requestParameters.multiplayerRoomNameUpdateBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateMultiplayerSkillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateMultiplayerSkill(requestParameters: QuestionApiApiQuestionApiUpdateMultiplayerSkillRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerSkillUpdateResponse> {
            return localVarFp.questionApiUpdateMultiplayerSkill(requestParameters.roomId, requestParameters.skillId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateOptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateOption(requestParameters: QuestionApiApiQuestionApiUpdateOptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateOptionResponse> {
            return localVarFp.questionApiUpdateOption(requestParameters.updateOptionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateQuestionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateQuestion(requestParameters: QuestionApiApiQuestionApiUpdateQuestionRequest, options?: RawAxiosRequestConfig): AxiosPromise<QuestionResponseSchemaSkillDict> {
            return localVarFp.questionApiUpdateQuestion(requestParameters.questionId, requestParameters.updateQuestionBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateUnderReviewDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateUnderReviewDetails(requestParameters: QuestionApiApiQuestionApiUpdateUnderReviewDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiUpdateUnderReviewDetails(requestParameters.questionId, requestParameters.updateUnderReviewBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateUnderReviewDetailsBulkRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateUnderReviewDetailsBulk(requestParameters: QuestionApiApiQuestionApiUpdateUnderReviewDetailsBulkRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiUpdateUnderReviewDetailsBulk(requestParameters.bulkUpdateUnderReviewStatusParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpdateUserGoalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpdateUserGoal(requestParameters: QuestionApiApiQuestionApiUpdateUserGoalRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserGoalResponse> {
            return localVarFp.questionApiUpdateUserGoal(requestParameters.goalId, requestParameters.updateUserGoalBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpsertUserQuestionFeedbackRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpsertUserQuestionFeedback(requestParameters: QuestionApiApiQuestionApiUpsertUserQuestionFeedbackRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiUpsertUserQuestionFeedback(requestParameters.questionId, requestParameters.userQuestionFeedbackParam, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiUpsertUserSkillTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiUpsertUserSkillTree(requestParameters: QuestionApiApiQuestionApiUpsertUserSkillTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.questionApiUpsertUserSkillTree(requestParameters.skillId, requestParameters.upsertUserSkillTreeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QuestionApiApiQuestionApiWidenMultiplayerSkillSearchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        questionApiWidenMultiplayerSkillSearch(requestParameters: QuestionApiApiQuestionApiWidenMultiplayerSkillSearchRequest, options?: RawAxiosRequestConfig): AxiosPromise<MultiplayerWidenSkillSearchResponse> {
            return localVarFp.questionApiWidenMultiplayerSkillSearch(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for questionApiAcceptAiMultiplayerInvite operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAcceptAiMultiplayerInviteRequest {
    readonly batchId: string
}

/**
 * Request parameters for questionApiAdminCreateUserGoal operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAdminCreateUserGoalRequest {
    readonly adminCreateUserGoalBody: AdminCreateUserGoalBody
}

/**
 * Request parameters for questionApiAdminUpdateQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAdminUpdateQuestionRequest {
    readonly questionId: string

    readonly updateQuestionBody: UpdateQuestionBody
}

/**
 * Request parameters for questionApiAiAssistantFeedback operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAiAssistantFeedbackRequest {
    readonly chatId: string

    readonly questionId: string

    readonly aIAssistantFeedbackBody: AIAssistantFeedbackBody
}

/**
 * Request parameters for questionApiAiEnhanceQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAiEnhanceQuestionRequest {
    readonly questionId: string

    readonly aIEnhanceQuestionBody: AIEnhanceQuestionBody
}

/**
 * Request parameters for questionApiAiHierarchyQuestionGeneration operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAiHierarchyQuestionGenerationRequest {
    readonly aIHierarchyQuestionGenerationBody: AIHierarchyQuestionGenerationBody
}

/**
 * Request parameters for questionApiAiSelfQuestionGeneration operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAiSelfQuestionGenerationRequest {
    readonly aIQuestionGenerationBody: AIQuestionGenerationBody
}

/**
 * Request parameters for questionApiApplyAiEnhanceQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiApplyAiEnhanceQuestionRequest {
    readonly questionId: string

    readonly applyAIEnhanceBody: ApplyAIEnhanceBody
}

/**
 * Request parameters for questionApiAttemptMultiplayerQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAttemptMultiplayerQuestionRequest {
    readonly questionId: string

    readonly roomId: string

    readonly attemptQuestionBody: AttemptQuestionBody
}

/**
 * Request parameters for questionApiAttemptQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAttemptQuestionRequest {
    readonly questionId: string

    readonly sessionId: string

    readonly attemptQuestionBody: AttemptQuestionBody
}

/**
 * Request parameters for questionApiAttemptQuestionByCompetition operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiAttemptQuestionByCompetitionRequest {
    readonly competitionId: string

    readonly questionId: string

    readonly attemptQuestionBody: AttemptQuestionBody
}

/**
 * Request parameters for questionApiBookmarkQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiBookmarkQuestionRequest {
    readonly questionId: string

    readonly bookmarkQuestionBody: BookmarkQuestionBody
}

/**
 * Request parameters for questionApiBulkActionsReviewQuestions operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiBulkActionsReviewQuestionsRequest {
    readonly bulkActionsReviewQuestionBody: BulkActionsReviewQuestionBody
}

/**
 * Request parameters for questionApiBulkBlockDuplicates operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiBulkBlockDuplicatesRequest {
    readonly duplicateQuestion: DuplicateQuestion
}

/**
 * Request parameters for questionApiCheckAndGeneratePromptQuestionsAvailability operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiCheckAndGeneratePromptQuestionsAvailabilityRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiCreateMultiplayerPersona operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiCreateMultiplayerPersonaRequest {
    readonly adminPersonaCreateBody: AdminPersonaCreateBody
}

/**
 * Request parameters for questionApiCreateQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiCreateQuestionRequest {
    readonly createQuestionBody: CreateQuestionBody
}

/**
 * Request parameters for questionApiCreateSlugTestapi operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiCreateSlugTestapiRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiCreateUserGoal operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiCreateUserGoalRequest {
    readonly createUserGoalBody: CreateUserGoalBody
}

/**
 * Request parameters for questionApiDeleteMultiplayerRoom operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiDeleteMultiplayerRoomRequest {
    readonly exitMultiplayerRoomBody: ExitMultiplayerRoomBody
}

/**
 * Request parameters for questionApiDeleteQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiDeleteQuestionRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiDeleteUserSkillHierarchy operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiDeleteUserSkillHierarchyRequest {
    readonly skillId: string
}

/**
 * Request parameters for questionApiEndMultiplayerGameByHost operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiEndMultiplayerGameByHostRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiExitMultiplayerRoom operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiExitMultiplayerRoomRequest {
    readonly exitMultiplayerRoomBody: ExitMultiplayerRoomBody
}

/**
 * Request parameters for questionApiGeneratePromptCurriculum operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGeneratePromptCurriculumRequest {
    readonly roomId: string

    readonly generatePromptCurriculumBody: GeneratePromptCurriculumBody
}

/**
 * Request parameters for questionApiGetAdminSkillTree operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetAdminSkillTreeRequest {
    readonly skillId: string

    readonly duplicateCutoff?: number

    readonly includeNoQuestionsSkills?: boolean

    readonly showDuplicate?: boolean
}

/**
 * Request parameters for questionApiGetAiQuestionGenerationStatus operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetAiQuestionGenerationStatusRequest {
    readonly taskId: string
}

/**
 * Request parameters for questionApiGetAllAiGenerationTasks operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetAllAiGenerationTasksRequest {
    readonly page?: string

    readonly pageSize?: string
}

/**
 * Request parameters for questionApiGetAnsweredAttemptById operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetAnsweredAttemptByIdRequest {
    readonly attemptId: string
}

/**
 * Request parameters for questionApiGetAnsweredQuestionHistoryList operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetAnsweredQuestionHistoryListRequest {
    readonly competitionId?: string

    readonly newestFirst?: boolean

    readonly page?: string

    readonly pageSize?: string

    readonly skillId?: string
}

/**
 * Request parameters for questionApiGetAnsweredQuestionList operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetAnsweredQuestionListRequest {
    readonly competitionId?: string

    readonly examId?: string

    readonly filterType?: string

    readonly page?: number

    readonly pageSize?: number

    readonly searchString?: string

    readonly skillIds?: Array<string>
}

/**
 * Request parameters for questionApiGetBlockedRoomUsers operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetBlockedRoomUsersRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiGetJoinedMultiplayerRooms operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetJoinedMultiplayerRoomsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly totalPages?: number
}

/**
 * Request parameters for questionApiGetMultiplayerGameHistory operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetMultiplayerGameHistoryRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiGetMultiplayerGameInfo operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetMultiplayerGameInfoRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiGetMultiplayerReadyUsers operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetMultiplayerReadyUsersRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiGetMultiplayerRoomInfo operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetMultiplayerRoomInfoRequest {
    readonly roomId: string

    readonly activeGameUsers?: boolean

    readonly entering?: boolean
}

/**
 * Request parameters for questionApiGetMultiplayerSessionHistory operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetMultiplayerSessionHistoryRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiGetPastPrompts operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetPastPromptsRequest {
    readonly roomId?: string | null
}

/**
 * Request parameters for questionApiGetPublicMultiplayerRoomInfo operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetPublicMultiplayerRoomInfoRequest {
    readonly roomCode: string
}

/**
 * Request parameters for questionApiGetQuestionAiAssistantChats operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionAiAssistantChatsRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiGetQuestionAttemptData operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionAttemptDataRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiGetQuestionById operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionByIdRequest {
    readonly questionId: string

    readonly subQuestions?: string
}

/**
 * Request parameters for questionApiGetQuestionExplanation operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionExplanationRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiGetQuestionHint operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionHintRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiGetQuestionReviewData operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionReviewDataRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiGetQuestionSkillHierarchies operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionSkillHierarchiesRequest {
    readonly ids?: Array<string>
}

/**
 * Request parameters for questionApiGetQuestionStatistics operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionStatisticsRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiGetQuestionUnderreviewList operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetQuestionUnderreviewListRequest {
    readonly duplicate?: string

    readonly page?: string

    readonly pageSize?: string

    readonly questionStatus?: string

    readonly sortBy?: string

    readonly sortOrder?: string

    readonly userId?: string
}

/**
 * Request parameters for questionApiGetRoomPastPrompts operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetRoomPastPromptsRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiGetSessionProgressMetrics operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetSessionProgressMetricsRequest {
    readonly sessionId: string

    readonly skillId: string
}

/**
 * Request parameters for questionApiGetSimilarQuestions operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetSimilarQuestionsRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiGetSkillTree operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetSkillTreeRequest {
    readonly skillId: string

    readonly includeNoQuestionsSkills?: boolean
}

/**
 * Request parameters for questionApiGetSolution operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetSolutionRequest {
    readonly questionId: string
}

/**
 * Request parameters for questionApiGetUnansweredQuestionBySkill operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetUnansweredQuestionBySkillRequest {
    readonly unansweredSkillQuestionBody: UnansweredSkillQuestionBody
}

/**
 * Request parameters for questionApiGetUnansweredQuestionSkillBuilder operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetUnansweredQuestionSkillBuilderRequest {
    readonly sessionId: string
}

/**
 * Request parameters for questionApiGetUserGoal operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetUserGoalRequest {
    readonly isArchived?: boolean

    readonly isTemplate?: boolean
}

/**
 * Request parameters for questionApiGetUserGoalById operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetUserGoalByIdRequest {
    readonly goalId: string
}

/**
 * Request parameters for questionApiGetUserSkillMilestone operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiGetUserSkillMilestoneRequest {
    readonly sessionId: string
}

/**
 * Request parameters for questionApiHandleHostTransferRequest operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiHandleHostTransferRequestRequest {
    readonly roomId: string

    readonly hostTransferBody: HostTransferBody
}

/**
 * Request parameters for questionApiHandleInactiveGame operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiHandleInactiveGameRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiHandleInactiveHostTransfer operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiHandleInactiveHostTransferRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiHandleMultiplayerGameEnd operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiHandleMultiplayerGameEndRequest {
    readonly roomId: string

    readonly hostTransferBody: HostTransferBody
}

/**
 * Request parameters for questionApiInitializeMultiplayerGame operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiInitializeMultiplayerGameRequest {
    readonly roomId: string

    readonly multiplayerGameInitializeBody: MultiplayerGameInitializeBody
}

/**
 * Request parameters for questionApiInviteToMultiplayerRoom operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiInviteToMultiplayerRoomRequest {
    readonly roomId: string

    readonly multiplayerInviteUsersBody: MultiplayerInviteUsersBody
}

/**
 * Request parameters for questionApiLeaveMultiplayerRoom operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiLeaveMultiplayerRoomRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiMultiplayerLeaderboard operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiMultiplayerLeaderboardRequest {
    readonly roomId: string

    readonly gameId?: string | null

    readonly resultType?: string

    readonly sessionId?: string | null
}

/**
 * Request parameters for questionApiMultiplayerReadyForNextSession operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiMultiplayerReadyForNextSessionRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiMultiplayerRoomLeaderboard operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiMultiplayerRoomLeaderboardRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiMuteMultiplayerInviter operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiMuteMultiplayerInviterRequest {
    readonly multiplayerMuteInviterBody: MultiplayerMuteInviterBody
}

/**
 * Request parameters for questionApiNudgeMulplayerUser operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiNudgeMulplayerUserRequest {
    readonly gameId: string

    readonly roomId: string

    readonly multiplayerNudgeUserBody: MultiplayerNudgeUserBody
}

/**
 * Request parameters for questionApiNudgeMulplayerUserInRoom operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiNudgeMulplayerUserInRoomRequest {
    readonly roomId: string

    readonly multiplayerNudgeUserBody: MultiplayerNudgeUserBody
}

/**
 * Request parameters for questionApiPopulateQuestionSimilarityEmbeddings operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiPopulateQuestionSimilarityEmbeddingsRequest {
    readonly skillID: SkillID
}

/**
 * Request parameters for questionApiPromptBasedQuestionsGeneration operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiPromptBasedQuestionsGenerationRequest {
    readonly gameId: string

    readonly roomId: string

    readonly multiplayerQuestionsGenerationBody: MultiplayerQuestionsGenerationBody
}

/**
 * Request parameters for questionApiQuestionAiAssistant operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiQuestionAiAssistantRequest {
    readonly questionId: string

    readonly questionAIAssistantBody: QuestionAIAssistantBody
}

/**
 * Request parameters for questionApiQuestionLike operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiQuestionLikeRequest {
    readonly questionId: string

    readonly likeDislikeQuestionBody: LikeDislikeQuestionBody
}

/**
 * Request parameters for questionApiQuestionPublicAttempt operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiQuestionPublicAttemptRequest {
    readonly questionPublicAttemptBody: Array<QuestionPublicAttemptBody>
}

/**
 * Request parameters for questionApiRecomputeQuestionDifficulty operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiRecomputeQuestionDifficultyRequest {
    readonly recomputeDifficultyBody: RecomputeDifficultyBody
}

/**
 * Request parameters for questionApiRecordMultiplayerInviteClick operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiRecordMultiplayerInviteClickRequest {
    readonly inviteId: string
}

/**
 * Request parameters for questionApiRemoveOrBlockMultiplayerUser operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiRemoveOrBlockMultiplayerUserRequest {
    readonly roomId: string

    readonly multiplayerRemoveOrBlockUserBody: MultiplayerRemoveOrBlockUserBody
}

/**
 * Request parameters for questionApiRequestHostChange operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiRequestHostChangeRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiRequestMultiplayerGameEnd operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiRequestMultiplayerGameEndRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiRescaleQuestionEmbeddingDimensions operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiRescaleQuestionEmbeddingDimensionsRequest {
    readonly rescaleQuestionEmbeddingDimensions: RescaleQuestionEmbeddingDimensions
}

/**
 * Request parameters for questionApiRespondAiMultiplayerInvite operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiRespondAiMultiplayerInviteRequest {
    readonly batchId: string

    readonly respondAiInviteBody: RespondAiInviteBody
}

/**
 * Request parameters for questionApiScheduleMultiplayerOfflineInvites operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiScheduleMultiplayerOfflineInvitesRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiSendMultiplayerReaction operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSendMultiplayerReactionRequest {
    readonly gameId: string

    readonly roomId: string

    readonly multiplayerReactionBody: MultiplayerReactionBody
}

/**
 * Request parameters for questionApiSetMultiplayerInvitePreference operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSetMultiplayerInvitePreferenceRequest {
    readonly multiplayerInvitePreferenceBody: MultiplayerInvitePreferenceBody
}

/**
 * Request parameters for questionApiSkillBuilderMultiplayerHost operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSkillBuilderMultiplayerHostRequest {
    readonly skillBuilderMultiplayerHostSessionParam: SkillBuilderMultiplayerHostSessionParam
}

/**
 * Request parameters for questionApiSkillBuilderMultiplayerJoin operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSkillBuilderMultiplayerJoinRequest {
    readonly skillBuilderMultiplayerJoinSessionParam: SkillBuilderMultiplayerJoinSessionParam
}

/**
 * Request parameters for questionApiSkillBuilderMultiplayerSessionProgress operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionProgressRequest {
    readonly roomId: string

    readonly sessionId: string
}

/**
 * Request parameters for questionApiSkillBuilderMultiplayerSessionStartStatistics operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionStartStatisticsRequest {
    readonly roomId: string
}

/**
 * Request parameters for questionApiSkillBuilderMultiplayerStartSession operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSkillBuilderMultiplayerStartSessionRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiSkillBuilderMultiplayerStartWithPersona operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSkillBuilderMultiplayerStartWithPersonaRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * Request parameters for questionApiSkillBuilderSessionEnd operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSkillBuilderSessionEndRequest {
    readonly sessionId: string

    readonly skillId: string

    readonly userSessionEndParam: UserSessionEndParam
}

/**
 * Request parameters for questionApiSkillBuilderSessionStart operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSkillBuilderSessionStartRequest {
    readonly skillId: string

    readonly nestedSkillID: NestedSkillID
}

/**
 * Request parameters for questionApiSolutionRating operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiSolutionRatingRequest {
    readonly questionId: string

    readonly solutionRatingBody: SolutionRatingBody
}

/**
 * Request parameters for questionApiStopAiQuestionGeneration operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiStopAiQuestionGenerationRequest {
    readonly taskId: string
}

/**
 * Request parameters for questionApiTransferRoomAdmin operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiTransferRoomAdminRequest {
    readonly roomId: string

    readonly transferRoomAdminBody: TransferRoomAdminBody
}

/**
 * Request parameters for questionApiUnblockMultiplayerUser operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUnblockMultiplayerUserRequest {
    readonly roomId: string

    readonly unblockMultiplayerUserBody: UnblockMultiplayerUserBody
}

/**
 * Request parameters for questionApiUpdateAiMultiplayerInviteSetting operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateAiMultiplayerInviteSettingRequest {
    readonly aiInviteSettingUpdateBody: AiInviteSettingUpdateBody
}

/**
 * Request parameters for questionApiUpdateMultiplayerPersona operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateMultiplayerPersonaRequest {
    readonly personaId: string

    readonly adminPersonaUpdateBody: AdminPersonaUpdateBody
}

/**
 * Request parameters for questionApiUpdateMultiplayerPromptText operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateMultiplayerPromptTextRequest {
    readonly roomId: string

    readonly multiplayerPromptUpdateBody: MultiplayerPromptUpdateBody
}

/**
 * Request parameters for questionApiUpdateMultiplayerRoomName operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateMultiplayerRoomNameRequest {
    readonly roomId: string

    readonly multiplayerRoomNameUpdateBody: MultiplayerRoomNameUpdateBody
}

/**
 * Request parameters for questionApiUpdateMultiplayerSkill operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateMultiplayerSkillRequest {
    readonly roomId: string

    readonly skillId: string
}

/**
 * Request parameters for questionApiUpdateOption operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateOptionRequest {
    readonly updateOptionBody: UpdateOptionBody
}

/**
 * Request parameters for questionApiUpdateQuestion operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateQuestionRequest {
    readonly questionId: string

    readonly updateQuestionBody: UpdateQuestionBody
}

/**
 * Request parameters for questionApiUpdateUnderReviewDetails operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateUnderReviewDetailsRequest {
    readonly questionId: string

    readonly updateUnderReviewBody: UpdateUnderReviewBody
}

/**
 * Request parameters for questionApiUpdateUnderReviewDetailsBulk operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateUnderReviewDetailsBulkRequest {
    readonly bulkUpdateUnderReviewStatusParam: BulkUpdateUnderReviewStatusParam
}

/**
 * Request parameters for questionApiUpdateUserGoal operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpdateUserGoalRequest {
    readonly goalId: string

    readonly updateUserGoalBody: UpdateUserGoalBody
}

/**
 * Request parameters for questionApiUpsertUserQuestionFeedback operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpsertUserQuestionFeedbackRequest {
    readonly questionId: string

    readonly userQuestionFeedbackParam: UserQuestionFeedbackParam
}

/**
 * Request parameters for questionApiUpsertUserSkillTree operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiUpsertUserSkillTreeRequest {
    readonly skillId: string

    readonly upsertUserSkillTreeBody: UpsertUserSkillTreeBody
}

/**
 * Request parameters for questionApiWidenMultiplayerSkillSearch operation in QuestionApiApi.
 */
export interface QuestionApiApiQuestionApiWidenMultiplayerSkillSearchRequest {
    readonly gameId: string

    readonly roomId: string
}

/**
 * QuestionApiApi - object-oriented interface
 */
export class QuestionApiApi extends BaseAPI {
    /**
     * 
     * @param {QuestionApiApiQuestionApiAcceptAiMultiplayerInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAcceptAiMultiplayerInvite(requestParameters: QuestionApiApiQuestionApiAcceptAiMultiplayerInviteRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAcceptAiMultiplayerInvite(requestParameters.batchId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAdminCreateUserGoalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAdminCreateUserGoal(requestParameters: QuestionApiApiQuestionApiAdminCreateUserGoalRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAdminCreateUserGoal(requestParameters.adminCreateUserGoalBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAdminUpdateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAdminUpdateQuestion(requestParameters: QuestionApiApiQuestionApiAdminUpdateQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAdminUpdateQuestion(requestParameters.questionId, requestParameters.updateQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAiAssistantFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAiAssistantFeedback(requestParameters: QuestionApiApiQuestionApiAiAssistantFeedbackRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAiAssistantFeedback(requestParameters.chatId, requestParameters.questionId, requestParameters.aIAssistantFeedbackBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAiEnhanceQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAiEnhanceQuestion(requestParameters: QuestionApiApiQuestionApiAiEnhanceQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAiEnhanceQuestion(requestParameters.questionId, requestParameters.aIEnhanceQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAiHierarchyQuestionGenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAiHierarchyQuestionGeneration(requestParameters: QuestionApiApiQuestionApiAiHierarchyQuestionGenerationRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAiHierarchyQuestionGeneration(requestParameters.aIHierarchyQuestionGenerationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAiSelfQuestionGenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAiSelfQuestionGeneration(requestParameters: QuestionApiApiQuestionApiAiSelfQuestionGenerationRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAiSelfQuestionGeneration(requestParameters.aIQuestionGenerationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiApplyAiEnhanceQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiApplyAiEnhanceQuestion(requestParameters: QuestionApiApiQuestionApiApplyAiEnhanceQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiApplyAiEnhanceQuestion(requestParameters.questionId, requestParameters.applyAIEnhanceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAttemptMultiplayerQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAttemptMultiplayerQuestion(requestParameters: QuestionApiApiQuestionApiAttemptMultiplayerQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAttemptMultiplayerQuestion(requestParameters.questionId, requestParameters.roomId, requestParameters.attemptQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAttemptQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAttemptQuestion(requestParameters: QuestionApiApiQuestionApiAttemptQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAttemptQuestion(requestParameters.questionId, requestParameters.sessionId, requestParameters.attemptQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiAttemptQuestionByCompetitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiAttemptQuestionByCompetition(requestParameters: QuestionApiApiQuestionApiAttemptQuestionByCompetitionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiAttemptQuestionByCompetition(requestParameters.competitionId, requestParameters.questionId, requestParameters.attemptQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiBookmarkQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiBookmarkQuestion(requestParameters: QuestionApiApiQuestionApiBookmarkQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiBookmarkQuestion(requestParameters.questionId, requestParameters.bookmarkQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiBulkActionsReviewQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiBulkActionsReviewQuestions(requestParameters: QuestionApiApiQuestionApiBulkActionsReviewQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiBulkActionsReviewQuestions(requestParameters.bulkActionsReviewQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiBulkBlockDuplicatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiBulkBlockDuplicates(requestParameters: QuestionApiApiQuestionApiBulkBlockDuplicatesRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiBulkBlockDuplicates(requestParameters.duplicateQuestion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiCheckAndGeneratePromptQuestionsAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiCheckAndGeneratePromptQuestionsAvailability(requestParameters: QuestionApiApiQuestionApiCheckAndGeneratePromptQuestionsAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiCheckAndGeneratePromptQuestionsAvailability(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiCreateMultiplayerPersonaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiCreateMultiplayerPersona(requestParameters: QuestionApiApiQuestionApiCreateMultiplayerPersonaRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiCreateMultiplayerPersona(requestParameters.adminPersonaCreateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiCreateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiCreateQuestion(requestParameters: QuestionApiApiQuestionApiCreateQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiCreateQuestion(requestParameters.createQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiCreateSlugTestapiRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiCreateSlugTestapi(requestParameters: QuestionApiApiQuestionApiCreateSlugTestapiRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiCreateSlugTestapi(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiCreateUserGoalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiCreateUserGoal(requestParameters: QuestionApiApiQuestionApiCreateUserGoalRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiCreateUserGoal(requestParameters.createUserGoalBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiDeleteBlockedQuestionApi(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiDeleteBlockedQuestionApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiDeleteMultiplayerRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiDeleteMultiplayerRoom(requestParameters: QuestionApiApiQuestionApiDeleteMultiplayerRoomRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiDeleteMultiplayerRoom(requestParameters.exitMultiplayerRoomBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiDeleteQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiDeleteQuestion(requestParameters: QuestionApiApiQuestionApiDeleteQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiDeleteQuestion(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiDeleteUserSkillHierarchyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiDeleteUserSkillHierarchy(requestParameters: QuestionApiApiQuestionApiDeleteUserSkillHierarchyRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiDeleteUserSkillHierarchy(requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiEndMultiplayerGameByHostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiEndMultiplayerGameByHost(requestParameters: QuestionApiApiQuestionApiEndMultiplayerGameByHostRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiEndMultiplayerGameByHost(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiEscapeHtmlCharacters(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiEscapeHtmlCharacters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiExitMultiplayerRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiExitMultiplayerRoom(requestParameters: QuestionApiApiQuestionApiExitMultiplayerRoomRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiExitMultiplayerRoom(requestParameters.exitMultiplayerRoomBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGeneratePromptCurriculumRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGeneratePromptCurriculum(requestParameters: QuestionApiApiQuestionApiGeneratePromptCurriculumRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGeneratePromptCurriculum(requestParameters.roomId, requestParameters.generatePromptCurriculumBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetAdminSkillTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetAdminSkillTree(requestParameters: QuestionApiApiQuestionApiGetAdminSkillTreeRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetAdminSkillTree(requestParameters.skillId, requestParameters.duplicateCutoff, requestParameters.includeNoQuestionsSkills, requestParameters.showDuplicate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The AI-invite settings with what they produce right now (a dry run).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetAiMultiplayerInviteSettings(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetAiMultiplayerInviteSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetAiQuestionGenerationStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetAiQuestionGenerationStatus(requestParameters: QuestionApiApiQuestionApiGetAiQuestionGenerationStatusRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetAiQuestionGenerationStatus(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetAllAiGenerationTasksRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetAllAiGenerationTasks(requestParameters: QuestionApiApiQuestionApiGetAllAiGenerationTasksRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetAllAiGenerationTasks(requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetAnsweredAttemptByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetAnsweredAttemptById(requestParameters: QuestionApiApiQuestionApiGetAnsweredAttemptByIdRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetAnsweredAttemptById(requestParameters.attemptId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetAnsweredQuestionHistoryListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetAnsweredQuestionHistoryList(requestParameters: QuestionApiApiQuestionApiGetAnsweredQuestionHistoryListRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetAnsweredQuestionHistoryList(requestParameters.competitionId, requestParameters.newestFirst, requestParameters.page, requestParameters.pageSize, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetAnsweredQuestionListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetAnsweredQuestionList(requestParameters: QuestionApiApiQuestionApiGetAnsweredQuestionListRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetAnsweredQuestionList(requestParameters.competitionId, requestParameters.examId, requestParameters.filterType, requestParameters.page, requestParameters.pageSize, requestParameters.searchString, requestParameters.skillIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetBlockedRoomUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetBlockedRoomUsers(requestParameters: QuestionApiApiQuestionApiGetBlockedRoomUsersRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetBlockedRoomUsers(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetJoinedMultiplayerRoomsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetJoinedMultiplayerRooms(requestParameters: QuestionApiApiQuestionApiGetJoinedMultiplayerRoomsRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetJoinedMultiplayerRooms(requestParameters.page, requestParameters.pageSize, requestParameters.totalPages, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetMultiplayerGameHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetMultiplayerGameHistory(requestParameters: QuestionApiApiQuestionApiGetMultiplayerGameHistoryRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetMultiplayerGameHistory(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetMultiplayerGameInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetMultiplayerGameInfo(requestParameters: QuestionApiApiQuestionApiGetMultiplayerGameInfoRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetMultiplayerGameInfo(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetMultiplayerReadyUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetMultiplayerReadyUsers(requestParameters: QuestionApiApiQuestionApiGetMultiplayerReadyUsersRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetMultiplayerReadyUsers(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetMultiplayerRoomInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetMultiplayerRoomInfo(requestParameters: QuestionApiApiQuestionApiGetMultiplayerRoomInfoRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetMultiplayerRoomInfo(requestParameters.roomId, requestParameters.activeGameUsers, requestParameters.entering, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetMultiplayerSessionHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetMultiplayerSessionHistory(requestParameters: QuestionApiApiQuestionApiGetMultiplayerSessionHistoryRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetMultiplayerSessionHistory(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetMultiplayerStats(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetMultiplayerStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetPastPromptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetPastPrompts(requestParameters: QuestionApiApiQuestionApiGetPastPromptsRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetPastPrompts(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetPublicMultiplayerRoomInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetPublicMultiplayerRoomInfo(requestParameters: QuestionApiApiQuestionApiGetPublicMultiplayerRoomInfoRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetPublicMultiplayerRoomInfo(requestParameters.roomCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionAiAssistantChatsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionAiAssistantChats(requestParameters: QuestionApiApiQuestionApiGetQuestionAiAssistantChatsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionAiAssistantChats(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionAttemptDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionAttemptData(requestParameters: QuestionApiApiQuestionApiGetQuestionAttemptDataRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionAttemptData(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionById(requestParameters: QuestionApiApiQuestionApiGetQuestionByIdRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionById(requestParameters.questionId, requestParameters.subQuestions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionExplanationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionExplanation(requestParameters: QuestionApiApiQuestionApiGetQuestionExplanationRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionExplanation(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionHintRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionHint(requestParameters: QuestionApiApiQuestionApiGetQuestionHintRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionHint(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionReviewDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionReviewData(requestParameters: QuestionApiApiQuestionApiGetQuestionReviewDataRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionReviewData(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionSkillHierarchiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionSkillHierarchies(requestParameters: QuestionApiApiQuestionApiGetQuestionSkillHierarchiesRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionSkillHierarchies(requestParameters.ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionStatistics(requestParameters: QuestionApiApiQuestionApiGetQuestionStatisticsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionStatistics(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetQuestionUnderreviewListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetQuestionUnderreviewList(requestParameters: QuestionApiApiQuestionApiGetQuestionUnderreviewListRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetQuestionUnderreviewList(requestParameters.duplicate, requestParameters.page, requestParameters.pageSize, requestParameters.questionStatus, requestParameters.sortBy, requestParameters.sortOrder, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetRoomPastPromptsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetRoomPastPrompts(requestParameters: QuestionApiApiQuestionApiGetRoomPastPromptsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetRoomPastPrompts(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetSessionProgressMetricsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetSessionProgressMetrics(requestParameters: QuestionApiApiQuestionApiGetSessionProgressMetricsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetSessionProgressMetrics(requestParameters.sessionId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetSimilarQuestionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetSimilarQuestions(requestParameters: QuestionApiApiQuestionApiGetSimilarQuestionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetSimilarQuestions(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetSkillTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetSkillTree(requestParameters: QuestionApiApiQuestionApiGetSkillTreeRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetSkillTree(requestParameters.skillId, requestParameters.includeNoQuestionsSkills, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetSolutionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetSolution(requestParameters: QuestionApiApiQuestionApiGetSolutionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetSolution(requestParameters.questionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetUnansweredQuestionBySkillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetUnansweredQuestionBySkill(requestParameters: QuestionApiApiQuestionApiGetUnansweredQuestionBySkillRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetUnansweredQuestionBySkill(requestParameters.unansweredSkillQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetUnansweredQuestionSkillBuilderRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetUnansweredQuestionSkillBuilder(requestParameters: QuestionApiApiQuestionApiGetUnansweredQuestionSkillBuilderRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetUnansweredQuestionSkillBuilder(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetUserGoalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetUserGoal(requestParameters: QuestionApiApiQuestionApiGetUserGoalRequest = {}, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetUserGoal(requestParameters.isArchived, requestParameters.isTemplate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetUserGoalByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetUserGoalById(requestParameters: QuestionApiApiQuestionApiGetUserGoalByIdRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetUserGoalById(requestParameters.goalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiGetUserSkillMilestoneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiGetUserSkillMilestone(requestParameters: QuestionApiApiQuestionApiGetUserSkillMilestoneRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiGetUserSkillMilestone(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiHandleHostTransferRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiHandleHostTransferRequest(requestParameters: QuestionApiApiQuestionApiHandleHostTransferRequestRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiHandleHostTransferRequest(requestParameters.roomId, requestParameters.hostTransferBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiHandleInactiveGameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiHandleInactiveGame(requestParameters: QuestionApiApiQuestionApiHandleInactiveGameRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiHandleInactiveGame(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiHandleInactiveHostTransferRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiHandleInactiveHostTransfer(requestParameters: QuestionApiApiQuestionApiHandleInactiveHostTransferRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiHandleInactiveHostTransfer(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiHandleMultiplayerGameEndRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiHandleMultiplayerGameEnd(requestParameters: QuestionApiApiQuestionApiHandleMultiplayerGameEndRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiHandleMultiplayerGameEnd(requestParameters.roomId, requestParameters.hostTransferBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiInitializeMultiplayerGameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiInitializeMultiplayerGame(requestParameters: QuestionApiApiQuestionApiInitializeMultiplayerGameRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiInitializeMultiplayerGame(requestParameters.roomId, requestParameters.multiplayerGameInitializeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiInviteToMultiplayerRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiInviteToMultiplayerRoom(requestParameters: QuestionApiApiQuestionApiInviteToMultiplayerRoomRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiInviteToMultiplayerRoom(requestParameters.roomId, requestParameters.multiplayerInviteUsersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiLeaveMultiplayerRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiLeaveMultiplayerRoom(requestParameters: QuestionApiApiQuestionApiLeaveMultiplayerRoomRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiLeaveMultiplayerRoom(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The AI opponent roster, with how each character has actually been playing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiListMultiplayerPersonas(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiListMultiplayerPersonas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiMultiplayerLeaderboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiMultiplayerLeaderboard(requestParameters: QuestionApiApiQuestionApiMultiplayerLeaderboardRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiMultiplayerLeaderboard(requestParameters.roomId, requestParameters.gameId, requestParameters.resultType, requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiMultiplayerReadyForNextSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiMultiplayerReadyForNextSession(requestParameters: QuestionApiApiQuestionApiMultiplayerReadyForNextSessionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiMultiplayerReadyForNextSession(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiMultiplayerRoomLeaderboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiMultiplayerRoomLeaderboard(requestParameters: QuestionApiApiQuestionApiMultiplayerRoomLeaderboardRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiMultiplayerRoomLeaderboard(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiMuteMultiplayerInviterRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiMuteMultiplayerInviter(requestParameters: QuestionApiApiQuestionApiMuteMultiplayerInviterRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiMuteMultiplayerInviter(requestParameters.multiplayerMuteInviterBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiNudgeMulplayerUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiNudgeMulplayerUser(requestParameters: QuestionApiApiQuestionApiNudgeMulplayerUserRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiNudgeMulplayerUser(requestParameters.gameId, requestParameters.roomId, requestParameters.multiplayerNudgeUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiNudgeMulplayerUserInRoomRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiNudgeMulplayerUserInRoom(requestParameters: QuestionApiApiQuestionApiNudgeMulplayerUserInRoomRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiNudgeMulplayerUserInRoom(requestParameters.roomId, requestParameters.multiplayerNudgeUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiPopulateQuestionMetadata(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiPopulateQuestionMetadata(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiPopulateQuestionSimilarityEmbeddingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiPopulateQuestionSimilarityEmbeddings(requestParameters: QuestionApiApiQuestionApiPopulateQuestionSimilarityEmbeddingsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiPopulateQuestionSimilarityEmbeddings(requestParameters.skillID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiPromptBasedQuestionsGenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiPromptBasedQuestionsGeneration(requestParameters: QuestionApiApiQuestionApiPromptBasedQuestionsGenerationRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiPromptBasedQuestionsGeneration(requestParameters.gameId, requestParameters.roomId, requestParameters.multiplayerQuestionsGenerationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiQuestionAiAssistantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiQuestionAiAssistant(requestParameters: QuestionApiApiQuestionApiQuestionAiAssistantRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiQuestionAiAssistant(requestParameters.questionId, requestParameters.questionAIAssistantBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiQuestionCreateMilestone(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiQuestionCreateMilestone(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiQuestionLikeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiQuestionLike(requestParameters: QuestionApiApiQuestionApiQuestionLikeRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiQuestionLike(requestParameters.questionId, requestParameters.likeDislikeQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiQuestionPublicAttemptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiQuestionPublicAttempt(requestParameters: QuestionApiApiQuestionApiQuestionPublicAttemptRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiQuestionPublicAttempt(requestParameters.questionPublicAttemptBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * enough real attempts from its correct rate. Runs async on the worker; optional `skill_ids` in the JSON body scope it to questions in those skills.
     * @summary Kick off the statistical difficulty recompute: re-levels every question with
     * @param {QuestionApiApiQuestionApiRecomputeQuestionDifficultyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiRecomputeQuestionDifficulty(requestParameters: QuestionApiApiQuestionApiRecomputeQuestionDifficultyRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiRecomputeQuestionDifficulty(requestParameters.recomputeDifficultyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiRecordMultiplayerInviteClickRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiRecordMultiplayerInviteClick(requestParameters: QuestionApiApiQuestionApiRecordMultiplayerInviteClickRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiRecordMultiplayerInviteClick(requestParameters.inviteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiRemoveOrBlockMultiplayerUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiRemoveOrBlockMultiplayerUser(requestParameters: QuestionApiApiQuestionApiRemoveOrBlockMultiplayerUserRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiRemoveOrBlockMultiplayerUser(requestParameters.roomId, requestParameters.multiplayerRemoveOrBlockUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiReplaceExternalImagesApi(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiReplaceExternalImagesApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiReplaceExternalTextsApi(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiReplaceExternalTextsApi(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiRequestHostChangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiRequestHostChange(requestParameters: QuestionApiApiQuestionApiRequestHostChangeRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiRequestHostChange(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiRequestMultiplayerGameEndRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiRequestMultiplayerGameEnd(requestParameters: QuestionApiApiQuestionApiRequestMultiplayerGameEndRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiRequestMultiplayerGameEnd(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiRescaleQuestionEmbeddingDimensionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiRescaleQuestionEmbeddingDimensions(requestParameters: QuestionApiApiQuestionApiRescaleQuestionEmbeddingDimensionsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiRescaleQuestionEmbeddingDimensions(requestParameters.rescaleQuestionEmbeddingDimensions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiRespondAiMultiplayerInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiRespondAiMultiplayerInvite(requestParameters: QuestionApiApiQuestionApiRespondAiMultiplayerInviteRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiRespondAiMultiplayerInvite(requestParameters.batchId, requestParameters.respondAiInviteBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary One tick now, ignoring the send frequency. Sends only if sending is on.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiRunAiMultiplayerInvitesNow(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiRunAiMultiplayerInvitesNow(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiScheduleMultiplayerOfflineInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiScheduleMultiplayerOfflineInvites(requestParameters: QuestionApiApiQuestionApiScheduleMultiplayerOfflineInvitesRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiScheduleMultiplayerOfflineInvites(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSendMultiplayerReactionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSendMultiplayerReaction(requestParameters: QuestionApiApiQuestionApiSendMultiplayerReactionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSendMultiplayerReaction(requestParameters.gameId, requestParameters.roomId, requestParameters.multiplayerReactionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSetMultiplayerInvitePreferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSetMultiplayerInvitePreference(requestParameters: QuestionApiApiQuestionApiSetMultiplayerInvitePreferenceRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSetMultiplayerInvitePreference(requestParameters.multiplayerInvitePreferenceBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerHostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSkillBuilderMultiplayerHost(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerHostRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSkillBuilderMultiplayerHost(requestParameters.skillBuilderMultiplayerHostSessionParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerJoinRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSkillBuilderMultiplayerJoin(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerJoinRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSkillBuilderMultiplayerJoin(requestParameters.skillBuilderMultiplayerJoinSessionParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionProgressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSkillBuilderMultiplayerSessionProgress(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionProgressRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSkillBuilderMultiplayerSessionProgress(requestParameters.roomId, requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionStartStatisticsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSkillBuilderMultiplayerSessionStartStatistics(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerSessionStartStatisticsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSkillBuilderMultiplayerSessionStartStatistics(requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerStartSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSkillBuilderMultiplayerStartSession(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerStartSessionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSkillBuilderMultiplayerStartSession(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSkillBuilderMultiplayerStartWithPersonaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSkillBuilderMultiplayerStartWithPersona(requestParameters: QuestionApiApiQuestionApiSkillBuilderMultiplayerStartWithPersonaRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSkillBuilderMultiplayerStartWithPersona(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSkillBuilderSessionEndRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSkillBuilderSessionEnd(requestParameters: QuestionApiApiQuestionApiSkillBuilderSessionEndRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSkillBuilderSessionEnd(requestParameters.sessionId, requestParameters.skillId, requestParameters.userSessionEndParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSkillBuilderSessionStartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSkillBuilderSessionStart(requestParameters: QuestionApiApiQuestionApiSkillBuilderSessionStartRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSkillBuilderSessionStart(requestParameters.skillId, requestParameters.nestedSkillID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiSolutionRatingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiSolutionRating(requestParameters: QuestionApiApiQuestionApiSolutionRatingRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiSolutionRating(requestParameters.questionId, requestParameters.solutionRatingBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiStopAiQuestionGenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiStopAiQuestionGeneration(requestParameters: QuestionApiApiQuestionApiStopAiQuestionGenerationRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiStopAiQuestionGeneration(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiTransferRoomAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiTransferRoomAdmin(requestParameters: QuestionApiApiQuestionApiTransferRoomAdminRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiTransferRoomAdmin(requestParameters.roomId, requestParameters.transferRoomAdminBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUnblockMultiplayerUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUnblockMultiplayerUser(requestParameters: QuestionApiApiQuestionApiUnblockMultiplayerUserRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUnblockMultiplayerUser(requestParameters.roomId, requestParameters.unblockMultiplayerUserBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateAiMultiplayerInviteSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateAiMultiplayerInviteSetting(requestParameters: QuestionApiApiQuestionApiUpdateAiMultiplayerInviteSettingRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateAiMultiplayerInviteSetting(requestParameters.aiInviteSettingUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateBookmarkCount(options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateBookmarkCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * a delete would take the opponent off past players\' result screens.
     * @summary Rename, re-skin, re-band or retire a character. Retiring is is_active=False —
     * @param {QuestionApiApiQuestionApiUpdateMultiplayerPersonaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateMultiplayerPersona(requestParameters: QuestionApiApiQuestionApiUpdateMultiplayerPersonaRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateMultiplayerPersona(requestParameters.personaId, requestParameters.adminPersonaUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateMultiplayerPromptTextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateMultiplayerPromptText(requestParameters: QuestionApiApiQuestionApiUpdateMultiplayerPromptTextRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateMultiplayerPromptText(requestParameters.roomId, requestParameters.multiplayerPromptUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateMultiplayerRoomNameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateMultiplayerRoomName(requestParameters: QuestionApiApiQuestionApiUpdateMultiplayerRoomNameRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateMultiplayerRoomName(requestParameters.roomId, requestParameters.multiplayerRoomNameUpdateBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateMultiplayerSkillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateMultiplayerSkill(requestParameters: QuestionApiApiQuestionApiUpdateMultiplayerSkillRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateMultiplayerSkill(requestParameters.roomId, requestParameters.skillId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateOptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateOption(requestParameters: QuestionApiApiQuestionApiUpdateOptionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateOption(requestParameters.updateOptionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateQuestionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateQuestion(requestParameters: QuestionApiApiQuestionApiUpdateQuestionRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateQuestion(requestParameters.questionId, requestParameters.updateQuestionBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateUnderReviewDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateUnderReviewDetails(requestParameters: QuestionApiApiQuestionApiUpdateUnderReviewDetailsRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateUnderReviewDetails(requestParameters.questionId, requestParameters.updateUnderReviewBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateUnderReviewDetailsBulkRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateUnderReviewDetailsBulk(requestParameters: QuestionApiApiQuestionApiUpdateUnderReviewDetailsBulkRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateUnderReviewDetailsBulk(requestParameters.bulkUpdateUnderReviewStatusParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpdateUserGoalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpdateUserGoal(requestParameters: QuestionApiApiQuestionApiUpdateUserGoalRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpdateUserGoal(requestParameters.goalId, requestParameters.updateUserGoalBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpsertUserQuestionFeedbackRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpsertUserQuestionFeedback(requestParameters: QuestionApiApiQuestionApiUpsertUserQuestionFeedbackRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpsertUserQuestionFeedback(requestParameters.questionId, requestParameters.userQuestionFeedbackParam, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiUpsertUserSkillTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiUpsertUserSkillTree(requestParameters: QuestionApiApiQuestionApiUpsertUserSkillTreeRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiUpsertUserSkillTree(requestParameters.skillId, requestParameters.upsertUserSkillTreeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QuestionApiApiQuestionApiWidenMultiplayerSkillSearchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public questionApiWidenMultiplayerSkillSearch(requestParameters: QuestionApiApiQuestionApiWidenMultiplayerSkillSearchRequest, options?: RawAxiosRequestConfig) {
        return QuestionApiApiFp(this.configuration).questionApiWidenMultiplayerSkillSearch(requestParameters.gameId, requestParameters.roomId, options).then((request) => request(this.axios, this.basePath));
    }
}

